import * as e from "react";
import { Children as t, Component as n, Fragment as r, createContext as i, createElement as a, forwardRef as o, isValidElement as s, useCallback as c, useContext as l, useEffect as u, useId as d, useInsertionEffect as f, useLayoutEffect as p, useMemo as m, useRef as h, useState as g } from "react";
import { Fragment as _, jsx as v, jsxs as y } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, S = Object.getOwnPropertyNames, C = Object.prototype.hasOwnProperty, w = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, T = (e, t) => {
	let n = {};
	for (var r in e) b(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || b(n, Symbol.toStringTag, { value: "Module" }), n;
}, E = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = S(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !C.call(e, s) && s !== n && b(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = x(t, s)) || r.enumerable
	});
	return e;
}, ee = (e) => C.call(e, "module.exports") ? e["module.exports"] : E(b({}, "__esModule", { value: !0 }), e), te = i({});
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/utils/use-constant.mjs
function ne(e) {
	let t = h(null);
	return t.current === null && (t.current = e()), t.current;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var re = typeof window < "u" ? p : u, ie = /* @__PURE__ */ i(null);
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/array.mjs
function ae(e, t) {
	e.indexOf(t) === -1 && e.push(t);
}
function oe(e, t) {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/clamp.mjs
var D = (e, t, n) => n > t ? t : n < e ? e : n;
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/format-error-message.mjs
function se(e, t) {
	return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/errors.mjs
var ce = () => {}, O = () => {};
typeof process < "u" && process.env.NODE_ENV !== "production" && (ce = (e, t, n) => {
	!e && typeof console < "u" && console.warn(se(t, n));
}, O = (e, t, n) => {
	if (!e) throw Error(se(t, n));
});
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/global-config.mjs
var k = {}, le = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), ue = (e) => typeof e == "object" && !!e, de = (e) => /^0[^.\s]+$/u.test(e);
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/memo.mjs
/*#__NO_SIDE_EFFECTS__*/
function fe(e) {
	let t;
	return () => (t === void 0 && (t = e()), t);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/noop.mjs
var A = /* @__NO_SIDE_EFFECTS__ */ (e) => e, pe = (...e) => e.reduce((e, t) => (n) => t(e(n))), me = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
	let r = t - e;
	return r ? (n - e) / r : 1;
}, he = class {
	constructor() {
		this.subscriptions = [];
	}
	add(e) {
		return ae(this.subscriptions, e), () => oe(this.subscriptions, e);
	}
	notify(e, t, n) {
		let r = this.subscriptions.length;
		if (r) if (r === 1) this.subscriptions[0](e, t, n);
		else for (let i = 0; i < r; i++) {
			let r = this.subscriptions[i];
			r && r(e, t, n);
		}
	}
	getSize() {
		return this.subscriptions.length;
	}
	clear() {
		this.subscriptions.length = 0;
	}
}, j = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, M = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, ge = /* @__NO_SIDE_EFFECTS__ */ (e, t) => t ? 1e3 / t * e : 0, _e = /* @__PURE__ */ new Set();
function ve(e, t, n) {
	e || _e.has(t) || (console.warn(se(t, n)), _e.add(t));
}
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/wrap.mjs
var ye = (e, t, n) => {
	let r = t - e;
	return ((n - e) % r + r) % r + e;
}, be = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, xe = 1e-7, Se = 12;
function Ce(e, t, n, r, i) {
	let a, o, s = 0;
	do
		o = t + (n - t) / 2, a = be(o, r, i) - e, a > 0 ? n = o : t = o;
	while (Math.abs(a) > xe && ++s < Se);
	return o;
}
/*#__NO_SIDE_EFFECTS__*/
function we(e, t, n, r) {
	if (e === t && n === r) return A;
	let i = (t) => Ce(t, 0, 1, e, n);
	return (e) => e === 0 || e === 1 ? e : be(i(e), t, r);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/easing/modifiers/mirror.mjs
var Te = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => t <= .5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Ee = /* @__NO_SIDE_EFFECTS__ */ (e) => (t) => 1 - e(1 - t), De = /*@__PURE__*/ we(.33, 1.53, .69, .99), Oe = /*@__PURE__*/ Ee(De), ke = /*@__PURE__*/ Te(Oe), Ae = (e) => e >= 1 ? 1 : (e *= 2) < 1 ? .5 * Oe(e) : .5 * (2 - 2 ** (-10 * (e - 1))), je = (e) => 1 - Math.sin(Math.acos(e)), Me = /* @__PURE__ */ Ee(je), Ne = /* @__PURE__ */ Te(je), Pe = /*@__PURE__*/ we(.42, 0, 1, 1), Fe = /*@__PURE__*/ we(0, 0, .58, 1), Ie = /*@__PURE__*/ we(.42, 0, .58, 1), Le = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] != "number";
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/easing/utils/get-easing-for-segment.mjs
/*#__NO_SIDE_EFFECTS__*/
function Re(e, t) {
	return /* @__PURE__ */ Le(e) ? e[ye(0, e.length, t)] : e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-utils@12.39.0/node_modules/motion-utils/dist/es/easing/utils/is-bezier-definition.mjs
var ze = /* @__NO_SIDE_EFFECTS__ */ (e) => Array.isArray(e) && typeof e[0] == "number", Be = {
	linear: A,
	easeIn: Pe,
	easeInOut: Ie,
	easeOut: Fe,
	circIn: je,
	circInOut: Ne,
	circOut: Me,
	backIn: Oe,
	backInOut: ke,
	backOut: De,
	anticipate: Ae
}, Ve = (e) => typeof e == "string", He = (e) => {
	if (/* @__PURE__ */ ze(e)) {
		O(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
		let [t, n, r, i] = e;
		return /* @__PURE__ */ we(t, n, r, i);
	} else if (Ve(e)) return O(Be[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), Be[e];
	return e;
}, Ue = [
	"setup",
	"read",
	"resolveKeyframes",
	"preUpdate",
	"update",
	"preRender",
	"render",
	"postRender"
];
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/frameloop/render-step.mjs
function We(e) {
	let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, i = !1, a = /* @__PURE__ */ new WeakSet(), o = {
		delta: 0,
		timestamp: 0,
		isProcessing: !1
	};
	function s(t) {
		a.has(t) && (c.schedule(t), e()), t(o);
	}
	let c = {
		schedule: (e, i = !1, o = !1) => {
			let s = o && r ? t : n;
			return i && a.add(e), s.add(e), e;
		},
		cancel: (e) => {
			n.delete(e), a.delete(e);
		},
		process: (e) => {
			if (o = e, r) {
				i = !0;
				return;
			}
			r = !0;
			let a = t;
			t = n, n = a, t.forEach(s), t.clear(), r = !1, i && (i = !1, c.process(e));
		}
	};
	return c;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/frameloop/batcher.mjs
var Ge = 40;
function Ke(e, t) {
	let n = !1, r = !0, i = {
		delta: 0,
		timestamp: 0,
		isProcessing: !1
	}, a = () => n = !0, o = Ue.reduce((e, t) => (e[t] = We(a), e), {}), { setup: s, read: c, resolveKeyframes: l, preUpdate: u, update: d, preRender: f, render: p, postRender: m } = o, h = () => {
		let a = k.useManualTiming, o = a ? i.timestamp : performance.now();
		n = !1, a || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(o - i.timestamp, Ge), 1)), i.timestamp = o, i.isProcessing = !0, s.process(i), c.process(i), l.process(i), u.process(i), d.process(i), f.process(i), p.process(i), m.process(i), i.isProcessing = !1, n && t && (r = !1, e(h));
	}, g = () => {
		n = !0, r = !0, i.isProcessing || e(h);
	};
	return {
		schedule: Ue.reduce((e, t) => {
			let r = o[t];
			return e[t] = (e, t = !1, i = !1) => (n || g(), r.schedule(e, t, i)), e;
		}, {}),
		cancel: (e) => {
			for (let t = 0; t < Ue.length; t++) o[Ue[t]].cancel(e);
		},
		state: i,
		steps: o
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/frameloop/frame.mjs
var { schedule: N, cancel: P, state: F, steps: qe } = /* @__PURE__ */ Ke(typeof requestAnimationFrame < "u" ? requestAnimationFrame : A, !0), Je;
function Ye() {
	Je = void 0;
}
var I = {
	now: () => (Je === void 0 && I.set(F.isProcessing || k.useManualTiming ? F.timestamp : performance.now()), Je),
	set: (e) => {
		Je = e, queueMicrotask(Ye);
	}
}, Xe = (e) => (t) => typeof t == "string" && t.startsWith(e), Ze = /*@__PURE__*/ Xe("--"), Qe = /*@__PURE__*/ Xe("var(--"), $e = (e) => Qe(e) ? et.test(e.split("/*")[0].trim()) : !1, et = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function tt(e) {
	return typeof e == "string" && e.split("/*")[0].includes("var(--");
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/numbers/index.mjs
var nt = {
	test: (e) => typeof e == "number",
	parse: parseFloat,
	transform: (e) => e
}, rt = {
	...nt,
	transform: (e) => D(0, 1, e)
}, it = {
	...nt,
	default: 1
}, at = (e) => Math.round(e * 1e5) / 1e5, ot = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/utils/is-nullish.mjs
function st(e) {
	return e == null;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/utils/single-color-regex.mjs
var ct = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, lt = (e, t) => (n) => !!(typeof n == "string" && ct.test(n) && n.startsWith(e) || t && !st(n) && Object.prototype.hasOwnProperty.call(n, t)), ut = (e, t, n) => (r) => {
	if (typeof r != "string") return r;
	let [i, a, o, s] = r.match(ot);
	return {
		[e]: parseFloat(i),
		[t]: parseFloat(a),
		[n]: parseFloat(o),
		alpha: s === void 0 ? 1 : parseFloat(s)
	};
}, dt = (e) => D(0, 255, e), ft = {
	...nt,
	transform: (e) => Math.round(dt(e))
}, pt = {
	test: /*@__PURE__*/ lt("rgb", "red"),
	parse: /*@__PURE__*/ ut("red", "green", "blue"),
	transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + ft.transform(e) + ", " + ft.transform(t) + ", " + ft.transform(n) + ", " + at(rt.transform(r)) + ")"
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/color/hex.mjs
function mt(e) {
	let t = "", n = "", r = "", i = "";
	return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
		red: parseInt(t, 16),
		green: parseInt(n, 16),
		blue: parseInt(r, 16),
		alpha: i ? parseInt(i, 16) / 255 : 1
	};
}
var ht = {
	test: /*@__PURE__*/ lt("#"),
	parse: mt,
	transform: pt.transform
}, gt = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
	test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
	parse: parseFloat,
	transform: (t) => `${t}${e}`
}), L = /*@__PURE__*/ gt("deg"), R = /*@__PURE__*/ gt("%"), z = /*@__PURE__*/ gt("px"), _t = /*@__PURE__*/ gt("vh"), vt = /*@__PURE__*/ gt("vw"), yt = {
	...R,
	parse: (e) => R.parse(e) / 100,
	transform: (e) => R.transform(e * 100)
}, bt = {
	test: /*@__PURE__*/ lt("hsl", "hue"),
	parse: /*@__PURE__*/ ut("hue", "saturation", "lightness"),
	transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + R.transform(at(t)) + ", " + R.transform(at(n)) + ", " + at(rt.transform(r)) + ")"
}, B = {
	test: (e) => pt.test(e) || ht.test(e) || bt.test(e),
	parse: (e) => pt.test(e) ? pt.parse(e) : bt.test(e) ? bt.parse(e) : ht.parse(e),
	transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? pt.transform(e) : bt.transform(e),
	getAnimatableNone: (e) => {
		let t = B.parse(e);
		return t.alpha = 0, B.transform(t);
	}
}, xt = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/complex/index.mjs
function St(e) {
	return isNaN(e) && typeof e == "string" && (e.match(ot)?.length || 0) + (e.match(xt)?.length || 0) > 0;
}
var Ct = "number", wt = "color", Tt = "var", Et = "var(", Dt = "${}", Ot = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function kt(e) {
	let t = e.toString(), n = [], r = {
		color: [],
		number: [],
		var: []
	}, i = [], a = 0;
	return {
		values: n,
		split: t.replace(Ot, (e) => (B.test(e) ? (r.color.push(a), i.push(wt), n.push(B.parse(e))) : e.startsWith(Et) ? (r.var.push(a), i.push(Tt), n.push(e)) : (r.number.push(a), i.push(Ct), n.push(parseFloat(e))), ++a, Dt)).split(Dt),
		indexes: r,
		types: i
	};
}
function At(e) {
	return kt(e).values;
}
function jt({ split: e, types: t }) {
	let n = e.length;
	return (r) => {
		let i = "";
		for (let a = 0; a < n; a++) if (i += e[a], r[a] !== void 0) {
			let e = t[a];
			e === Ct ? i += at(r[a]) : e === wt ? i += B.transform(r[a]) : i += r[a];
		}
		return i;
	};
}
function Mt(e) {
	return jt(kt(e));
}
var Nt = (e) => typeof e == "number" ? 0 : B.test(e) ? B.getAnimatableNone(e) : e, Pt = (e, t) => typeof e == "number" ? t?.trim().endsWith("/") ? e : 0 : Nt(e);
function Ft(e) {
	let t = kt(e);
	return jt(t)(t.values.map((e, n) => Pt(e, t.split[n])));
}
var V = {
	test: St,
	parse: At,
	createTransformer: Mt,
	getAnimatableNone: Ft
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/color/hsla-to-rgba.mjs
function It(e, t, n) {
	return n < 0 && (n += 1), n > 1 && --n, n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Lt({ hue: e, saturation: t, lightness: n, alpha: r }) {
	e /= 360, t /= 100, n /= 100;
	let i = 0, a = 0, o = 0;
	if (!t) i = a = o = n;
	else {
		let r = n < .5 ? n * (1 + t) : n + t - n * t, s = 2 * n - r;
		i = It(s, r, e + 1 / 3), a = It(s, r, e), o = It(s, r, e - 1 / 3);
	}
	return {
		red: Math.round(i * 255),
		green: Math.round(a * 255),
		blue: Math.round(o * 255),
		alpha: r
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/mix/immediate.mjs
function Rt(e, t) {
	return (n) => n > 0 ? t : e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/mix/number.mjs
var H = (e, t, n) => e + (t - e) * n, zt = (e, t, n) => {
	let r = e * e, i = n * (t * t - r) + r;
	return i < 0 ? 0 : Math.sqrt(i);
}, Bt = [
	ht,
	pt,
	bt
], Vt = (e) => Bt.find((t) => t.test(e));
function Ht(e) {
	let t = Vt(e);
	if (ce(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t) return !1;
	let n = t.parse(e);
	return t === bt && (n = Lt(n)), n;
}
var Ut = (e, t) => {
	let n = Ht(e), r = Ht(t);
	if (!n || !r) return Rt(e, t);
	let i = { ...n };
	return (e) => (i.red = zt(n.red, r.red, e), i.green = zt(n.green, r.green, e), i.blue = zt(n.blue, r.blue, e), i.alpha = H(n.alpha, r.alpha, e), pt.transform(i));
}, Wt = /* @__PURE__ */ new Set(["none", "hidden"]);
function Gt(e, t) {
	return Wt.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/mix/complex.mjs
function Kt(e, t) {
	return (n) => H(e, t, n);
}
function qt(e) {
	return typeof e == "number" ? Kt : typeof e == "string" ? $e(e) ? Rt : B.test(e) ? Ut : Zt : Array.isArray(e) ? Jt : typeof e == "object" ? B.test(e) ? Ut : Yt : Rt;
}
function Jt(e, t) {
	let n = [...e], r = n.length, i = e.map((e, n) => qt(e)(e, t[n]));
	return (e) => {
		for (let t = 0; t < r; t++) n[t] = i[t](e);
		return n;
	};
}
function Yt(e, t) {
	let n = {
		...e,
		...t
	}, r = {};
	for (let i in n) e[i] !== void 0 && t[i] !== void 0 && (r[i] = qt(e[i])(e[i], t[i]));
	return (e) => {
		for (let t in r) n[t] = r[t](e);
		return n;
	};
}
function Xt(e, t) {
	let n = [], r = {
		color: 0,
		var: 0,
		number: 0
	};
	for (let i = 0; i < t.values.length; i++) {
		let a = t.types[i], o = e.indexes[a][r[a]];
		n[i] = e.values[o] ?? 0, r[a]++;
	}
	return n;
}
var Zt = (e, t) => {
	let n = V.createTransformer(t), r = kt(e), i = kt(t);
	return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? Wt.has(e) && !i.values.length || Wt.has(t) && !r.values.length ? Gt(e, t) : pe(Jt(Xt(r, i), i.values), n) : (ce(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Rt(e, t));
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/mix/index.mjs
function Qt(e, t, n) {
	return typeof e == "number" && typeof t == "number" && typeof n == "number" ? H(e, t, n) : qt(e)(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/drivers/frame.mjs
var $t = (e) => {
	let t = ({ timestamp: t }) => e(t);
	return {
		start: (e = !0) => N.update(t, e),
		stop: () => P(t),
		now: () => F.isProcessing ? F.timestamp : I.now()
	};
}, en = (e, t, n = 10) => {
	let r = "", i = Math.max(Math.round(t / n), 2);
	for (let t = 0; t < i; t++) r += Math.round(e(t / (i - 1)) * 1e4) / 1e4 + ", ";
	return `linear(${r.substring(0, r.length - 2)})`;
}, tn = 2e4;
function nn(e) {
	let t = 0, n = e.next(t);
	for (; !n.done && t < 2e4;) t += 50, n = e.next(t);
	return t >= 2e4 ? Infinity : t;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/generators/utils/create-generator-easing.mjs
function rn(e, t = 100, n) {
	let r = n({
		...e,
		keyframes: [0, t]
	}), i = Math.min(nn(r), tn);
	return {
		type: "keyframes",
		ease: (e) => r.next(i * e).value / t,
		duration: /* @__PURE__ */ M(i)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/generators/spring.mjs
var U = {
	stiffness: 100,
	damping: 10,
	mass: 1,
	velocity: 0,
	duration: 800,
	bounce: .3,
	visualDuration: .3,
	restSpeed: {
		granular: .01,
		default: 2
	},
	restDelta: {
		granular: .005,
		default: .5
	},
	minDuration: .01,
	maxDuration: 10,
	minDamping: .05,
	maxDamping: 1
};
function an(e, t) {
	return e * Math.sqrt(1 - t * t);
}
var on = 12;
function sn(e, t, n) {
	let r = n;
	for (let n = 1; n < on; n++) r -= e(r) / t(r);
	return r;
}
var cn = .001;
function ln({ duration: e = U.duration, bounce: t = U.bounce, velocity: n = U.velocity, mass: r = U.mass }) {
	let i, a;
	ce(e <= /* @__PURE__ */ j(U.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
	let o = 1 - t;
	o = D(U.minDamping, U.maxDamping, o), e = D(U.minDuration, U.maxDuration, /* @__PURE__ */ M(e)), o < 1 ? (i = (t) => {
		let r = t * o, i = r * e, a = r - n, s = an(t, o), c = Math.exp(-i);
		return cn - a / s * c;
	}, a = (t) => {
		let r = t * o * e, a = r * n + n, s = o ** 2 * t ** 2 * e, c = Math.exp(-r), l = an(t ** 2, o);
		return (-i(t) + cn > 0 ? -1 : 1) * ((a - s) * c) / l;
	}) : (i = (t) => -.001 + Math.exp(-t * e) * ((t - n) * e + 1), a = (t) => Math.exp(-t * e) * ((n - t) * (e * e)));
	let s = 5 / e, c = sn(i, a, s);
	if (e = /* @__PURE__ */ j(e), isNaN(c)) return {
		stiffness: U.stiffness,
		damping: U.damping,
		duration: e
	};
	{
		let t = c ** 2 * r;
		return {
			stiffness: t,
			damping: o * 2 * Math.sqrt(r * t),
			duration: e
		};
	}
}
var un = ["duration", "bounce"], dn = [
	"stiffness",
	"damping",
	"mass"
];
function fn(e, t) {
	return t.some((t) => e[t] !== void 0);
}
function pn(e) {
	let t = {
		velocity: U.velocity,
		stiffness: U.stiffness,
		damping: U.damping,
		mass: U.mass,
		isResolvedFromDuration: !1,
		...e
	};
	if (!fn(e, dn) && fn(e, un)) if (t.velocity = 0, e.visualDuration) {
		let n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, a = 2 * D(.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
		t = {
			...t,
			mass: U.mass,
			stiffness: i,
			damping: a
		};
	} else {
		let n = ln({
			...e,
			velocity: 0
		});
		t = {
			...t,
			...n,
			mass: U.mass
		}, t.isResolvedFromDuration = !0;
	}
	return t;
}
function mn(e = U.visualDuration, t = U.bounce) {
	let n = typeof e == "object" ? e : {
		visualDuration: e,
		keyframes: [0, 1],
		bounce: t
	}, { restSpeed: r, restDelta: i } = n, a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], s = {
		done: !1,
		value: a
	}, { stiffness: c, damping: l, mass: u, duration: d, velocity: f, isResolvedFromDuration: p } = pn({
		...n,
		velocity: -/* @__PURE__ */ M(n.velocity || 0)
	}), m = f || 0, h = l / (2 * Math.sqrt(c * u)), g = o - a, _ = /* @__PURE__ */ M(Math.sqrt(c / u)), v = Math.abs(g) < 5;
	r ||= v ? U.restSpeed.granular : U.restSpeed.default, i ||= v ? U.restDelta.granular : U.restDelta.default;
	let y, b, x, S, C, w;
	if (h < 1) x = an(_, h), S = (m + h * _ * g) / x, y = (e) => {
		let t = Math.exp(-h * _ * e);
		return o - t * (S * Math.sin(x * e) + g * Math.cos(x * e));
	}, C = h * _ * S + g * x, w = h * _ * g - S * x, b = (e) => Math.exp(-h * _ * e) * (C * Math.sin(x * e) + w * Math.cos(x * e));
	else if (h === 1) {
		y = (e) => o - Math.exp(-_ * e) * (g + (m + _ * g) * e);
		let e = m + _ * g;
		b = (t) => Math.exp(-_ * t) * (_ * e * t - m);
	} else {
		let e = _ * Math.sqrt(h * h - 1);
		y = (t) => {
			let n = Math.exp(-h * _ * t), r = Math.min(e * t, 300);
			return o - n * ((m + h * _ * g) * Math.sinh(r) + e * g * Math.cosh(r)) / e;
		};
		let t = (m + h * _ * g) / e, n = h * _ * t - g * e, r = h * _ * g - t * e;
		b = (t) => {
			let i = Math.exp(-h * _ * t), a = Math.min(e * t, 300);
			return i * (n * Math.sinh(a) + r * Math.cosh(a));
		};
	}
	let T = {
		calculatedDuration: p && d || null,
		velocity: (e) => /* @__PURE__ */ j(b(e)),
		next: (e) => {
			if (!p && h < 1) {
				let t = Math.exp(-h * _ * e), n = Math.sin(x * e), a = Math.cos(x * e), c = o - t * (S * n + g * a), l = /* @__PURE__ */ j(t * (C * n + w * a));
				return s.done = Math.abs(l) <= r && Math.abs(o - c) <= i, s.value = s.done ? o : c, s;
			}
			let t = y(e);
			if (p) s.done = e >= d;
			else {
				let n = /* @__PURE__ */ j(b(e));
				s.done = Math.abs(n) <= r && Math.abs(o - t) <= i;
			}
			return s.value = s.done ? o : t, s;
		},
		toString: () => {
			let e = Math.min(nn(T), tn), t = en((t) => T.next(e * t).value, e, 30);
			return e + "ms " + t;
		},
		toTransition: () => {}
	};
	return T;
}
mn.applyToOptions = (e) => {
	let t = rn(e, 100, mn);
	return e.ease = t.ease, e.duration = /* @__PURE__ */ j(t.duration), e.type = "keyframes", e;
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/generators/utils/velocity.mjs
var hn = 5;
function gn(e, t, n) {
	let r = Math.max(t - hn, 0);
	return /* @__PURE__ */ ge(n - e(r), t - r);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/generators/inertia.mjs
function _n({ keyframes: e, velocity: t = 0, power: n = .8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: c, restDelta: l = .5, restSpeed: u }) {
	let d = e[0], f = {
		done: !1,
		value: d
	}, p = (e) => s !== void 0 && e < s || c !== void 0 && e > c, m = (e) => s === void 0 ? c : c === void 0 || Math.abs(s - e) < Math.abs(c - e) ? s : c, h = n * t, g = d + h, _ = o === void 0 ? g : o(g);
	_ !== g && (h = _ - d);
	let v = (e) => -h * Math.exp(-e / r), y = (e) => _ + v(e), b = (e) => {
		let t = v(e), n = y(e);
		f.done = Math.abs(t) <= l, f.value = f.done ? _ : n;
	}, x, S, C = (e) => {
		p(f.value) && (x = e, S = mn({
			keyframes: [f.value, m(f.value)],
			velocity: gn(y, e, f.value),
			damping: i,
			stiffness: a,
			restDelta: l,
			restSpeed: u
		}));
	};
	return C(0), {
		calculatedDuration: null,
		next: (e) => {
			let t = !1;
			return !S && x === void 0 && (t = !0, b(e), C(e)), x !== void 0 && e >= x ? S.next(e - x) : (!t && b(e), f);
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/interpolate.mjs
function vn(e, t, n) {
	let r = [], i = n || k.mix || Qt, a = e.length - 1;
	for (let n = 0; n < a; n++) {
		let a = i(e[n], e[n + 1]);
		t && (a = pe(Array.isArray(t) ? t[n] || A : t, a)), r.push(a);
	}
	return r;
}
function yn(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
	let a = e.length;
	if (O(a === t.length, "Both input and output ranges must be the same length", "range-length"), a === 1) return () => t[0];
	if (a === 2 && t[0] === t[1]) return () => t[1];
	let o = e[0] === e[1];
	e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
	let s = vn(t, r, i), c = s.length, l = (n) => {
		if (o && n < e[0]) return t[0];
		let r = 0;
		if (c > 1) for (; r < e.length - 2 && !(n < e[r + 1]); r++);
		let i = /* @__PURE__ */ me(e[r], e[r + 1], n);
		return s[r](i);
	};
	return n ? (t) => l(D(e[0], e[a - 1], t)) : l;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/offsets/fill.mjs
function bn(e, t) {
	let n = e[e.length - 1];
	for (let r = 1; r <= t; r++) {
		let i = /* @__PURE__ */ me(0, t, r);
		e.push(H(n, 1, i));
	}
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/offsets/default.mjs
function xn(e) {
	let t = [0];
	return bn(t, e.length - 1), t;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/offsets/time.mjs
function Sn(e, t) {
	return e.map((e) => e * t);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/generators/keyframes.mjs
function Cn(e, t) {
	return e.map(() => t || Ie).splice(0, e.length - 1);
}
function wn({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
	let i = /* @__PURE__ */ Le(r) ? r.map(He) : He(r), a = {
		done: !1,
		value: t[0]
	}, o = yn(Sn(n && n.length === t.length ? n : xn(t), e), t, { ease: Array.isArray(i) ? i : Cn(t, i) });
	return {
		calculatedDuration: e,
		next: (t) => (a.value = o(t), a.done = t >= e, a)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/get-final.mjs
var Tn = (e) => e !== null;
function En(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
	let a = e.filter(Tn), o = i < 0 || t && n !== "loop" && t % 2 == 1 ? 0 : a.length - 1;
	return !o || r === void 0 ? a[o] : r;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/replace-transition-type.mjs
var Dn = {
	decay: _n,
	inertia: _n,
	tween: wn,
	keyframes: wn,
	spring: mn
};
function On(e) {
	typeof e.type == "string" && (e.type = Dn[e.type]);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/WithPromise.mjs
var kn = class {
	constructor() {
		this.updateFinished();
	}
	get finished() {
		return this._finished;
	}
	updateFinished() {
		this._finished = new Promise((e) => {
			this.resolve = e;
		});
	}
	notifyFinished() {
		this.resolve();
	}
	then(e, t) {
		return this.finished.then(e, t);
	}
}, An = (e) => e / 100, jn = class extends kn {
	constructor(e) {
		super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
			done: !1,
			value: void 0
		}, this.stop = () => {
			let { motionValue: e } = this.options;
			e && e.updatedAt !== I.now() && this.tick(I.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
		}, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
	}
	initAnimation() {
		let { options: e } = this;
		On(e);
		let { type: t = wn, repeat: n = 0, repeatDelay: r = 0, repeatType: i, velocity: a = 0 } = e, { keyframes: o } = e, s = t || wn;
		process.env.NODE_ENV !== "production" && s !== wn && O(o.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${o}`, "spring-two-frames"), s !== wn && typeof o[0] != "number" && (this.mixKeyframes = pe(An, Qt(o[0], o[1])), o = [0, 100]);
		let c = s({
			...e,
			keyframes: o
		});
		i === "mirror" && (this.mirroredGenerator = s({
			...e,
			keyframes: [...o].reverse(),
			velocity: -a
		})), c.calculatedDuration === null && (c.calculatedDuration = nn(c));
		let { calculatedDuration: l } = c;
		this.calculatedDuration = l, this.resolvedDuration = l + r, this.totalDuration = this.resolvedDuration * (n + 1) - r, this.generator = c;
	}
	updateTime(e) {
		let t = Math.round(e - this.startTime) * this.playbackSpeed;
		this.holdTime === null ? this.currentTime = t : this.currentTime = this.holdTime;
	}
	tick(e, t = !1) {
		let { generator: n, totalDuration: r, mixKeyframes: i, mirroredGenerator: a, resolvedDuration: o, calculatedDuration: s } = this;
		if (this.startTime === null) return n.next(0);
		let { delay: c = 0, keyframes: l, repeat: u, repeatType: d, repeatDelay: f, type: p, onUpdate: m, finalKeyframe: h } = this.options;
		this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - r / this.speed, this.startTime)), t ? this.currentTime = e : this.updateTime(e);
		let g = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), _ = this.playbackSpeed >= 0 ? g < 0 : g > r;
		this.currentTime = Math.max(g, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = r);
		let v = this.currentTime, y = n;
		if (u) {
			let e = Math.min(this.currentTime, r) / o, t = Math.floor(e), n = e % 1;
			!n && e >= 1 && (n = 1), n === 1 && t--, t = Math.min(t, u + 1), t % 2 && (d === "reverse" ? (n = 1 - n, f && (n -= f / o)) : d === "mirror" && (y = a)), v = D(0, 1, n) * o;
		}
		let b;
		_ ? (this.delayState.value = l[0], b = this.delayState) : b = y.next(v), i && !_ && (b.value = i(b.value));
		let { done: x } = b;
		!_ && s !== null && (x = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0);
		let S = this.holdTime === null && (this.state === "finished" || this.state === "running" && x);
		return S && p !== _n && (b.value = En(l, this.options, h, this.speed)), m && m(b.value), S && this.finish(), b;
	}
	then(e, t) {
		return this.finished.then(e, t);
	}
	get duration() {
		return /* @__PURE__ */ M(this.calculatedDuration);
	}
	get iterationDuration() {
		let { delay: e = 0 } = this.options || {};
		return this.duration + /* @__PURE__ */ M(e);
	}
	get time() {
		return /* @__PURE__ */ M(this.currentTime);
	}
	set time(e) {
		e = /* @__PURE__ */ j(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = e, this.tick(e));
	}
	getGeneratorVelocity() {
		let e = this.currentTime;
		if (e <= 0) return this.options.velocity || 0;
		if (this.generator.velocity) return this.generator.velocity(e);
		let t = this.generator.next(e).value;
		return gn((e) => this.generator.next(e).value, e, t);
	}
	get speed() {
		return this.playbackSpeed;
	}
	set speed(e) {
		let t = this.playbackSpeed !== e;
		t && this.driver && this.updateTime(I.now()), this.playbackSpeed = e, t && this.driver && (this.time = /* @__PURE__ */ M(this.currentTime));
	}
	play() {
		if (this.isStopped) return;
		let { driver: e = $t, startTime: t } = this.options;
		this.driver ||= e((e) => this.tick(e)), this.options.onPlay?.();
		let n = this.driver.now();
		this.state === "finished" ? (this.updateFinished(), this.startTime = n) : this.holdTime === null ? this.startTime ||= t ?? n : this.startTime = n - this.holdTime, this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
	}
	pause() {
		this.state = "paused", this.updateTime(I.now()), this.holdTime = this.currentTime;
	}
	complete() {
		this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
	}
	finish() {
		this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
	}
	cancel() {
		this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
	}
	teardown() {
		this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
	}
	stopDriver() {
		this.driver &&= (this.driver.stop(), void 0);
	}
	sample(e) {
		return this.startTime = 0, this.tick(e, !0);
	}
	attachTimeline(e) {
		return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), e.observe(this);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/utils/fill-wildcards.mjs
function Mn(e) {
	for (let t = 1; t < e.length; t++) e[t] ?? (e[t] = e[t - 1]);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/dom/parse-transform.mjs
var Nn = (e) => e * 180 / Math.PI, Pn = (e) => In(Nn(Math.atan2(e[1], e[0]))), Fn = {
	x: 4,
	y: 5,
	translateX: 4,
	translateY: 5,
	scaleX: 0,
	scaleY: 3,
	scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
	rotate: Pn,
	rotateZ: Pn,
	skewX: (e) => Nn(Math.atan(e[1])),
	skewY: (e) => Nn(Math.atan(e[2])),
	skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, In = (e) => (e %= 360, e < 0 && (e += 360), e), Ln = Pn, Rn = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), zn = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), Bn = {
	x: 12,
	y: 13,
	z: 14,
	translateX: 12,
	translateY: 13,
	translateZ: 14,
	scaleX: Rn,
	scaleY: zn,
	scale: (e) => (Rn(e) + zn(e)) / 2,
	rotateX: (e) => In(Nn(Math.atan2(e[6], e[5]))),
	rotateY: (e) => In(Nn(Math.atan2(-e[2], e[0]))),
	rotateZ: Ln,
	rotate: Ln,
	skewX: (e) => Nn(Math.atan(e[4])),
	skewY: (e) => Nn(Math.atan(e[1])),
	skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function Vn(e) {
	return +!!e.includes("scale");
}
function Hn(e, t) {
	if (!e || e === "none") return Vn(t);
	let n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u), r, i;
	if (n) r = Bn, i = n;
	else {
		let t = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
		r = Fn, i = t;
	}
	if (!i) return Vn(t);
	let a = r[t], o = i[1].split(",").map(Wn);
	return typeof a == "function" ? a(o) : o[a];
}
var Un = (e, t) => {
	let { transform: n = "none" } = getComputedStyle(e);
	return Hn(n, t);
};
function Wn(e) {
	return parseFloat(e.trim());
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/keys-transform.mjs
var Gn = [
	"transformPerspective",
	"x",
	"y",
	"z",
	"translateX",
	"translateY",
	"translateZ",
	"scale",
	"scaleX",
	"scaleY",
	"rotate",
	"rotateX",
	"rotateY",
	"rotateZ",
	"skew",
	"skewX",
	"skewY"
], Kn = /* @__PURE__ */ new Set([...Gn, "pathRotation"]), qn = (e) => e === nt || e === z, Jn = /* @__PURE__ */ new Set([
	"x",
	"y",
	"z"
]), Yn = Gn.filter((e) => !Jn.has(e));
function Xn(e) {
	let t = [];
	return Yn.forEach((n) => {
		let r = e.getValue(n);
		r !== void 0 && (t.push([n, r.get()]), r.set(+!!n.startsWith("scale")));
	}), t;
}
var W = {
	width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0", boxSizing: r }) => {
		let i = e.max - e.min;
		return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
	},
	height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0", boxSizing: r }) => {
		let i = e.max - e.min;
		return r === "border-box" ? i : i - parseFloat(t) - parseFloat(n);
	},
	top: (e, { top: t }) => parseFloat(t),
	left: (e, { left: t }) => parseFloat(t),
	bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
	right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
	x: (e, { transform: t }) => Hn(t, "x"),
	y: (e, { transform: t }) => Hn(t, "y")
};
W.translateX = W.x, W.translateY = W.y;
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/KeyframesResolver.mjs
var Zn = /* @__PURE__ */ new Set(), Qn = !1, $n = !1, er = !1;
function tr() {
	if ($n) {
		let e = Array.from(Zn).filter((e) => e.needsMeasurement), t = new Set(e.map((e) => e.element)), n = /* @__PURE__ */ new Map();
		t.forEach((e) => {
			let t = Xn(e);
			t.length && (n.set(e, t), e.render());
		}), e.forEach((e) => e.measureInitialState()), t.forEach((e) => {
			e.render();
			let t = n.get(e);
			t && t.forEach(([t, n]) => {
				e.getValue(t)?.set(n);
			});
		}), e.forEach((e) => e.measureEndState()), e.forEach((e) => {
			e.suspendedScrollY !== void 0 && window.scrollTo(0, e.suspendedScrollY);
		});
	}
	$n = !1, Qn = !1, Zn.forEach((e) => e.complete(er)), Zn.clear();
}
function nr() {
	Zn.forEach((e) => {
		e.readKeyframes(), e.needsMeasurement && ($n = !0);
	});
}
function rr() {
	er = !0, nr(), tr(), er = !1;
}
var ir = class {
	constructor(e, t, n, r, i, a = !1) {
		this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = t, this.name = n, this.motionValue = r, this.element = i, this.isAsync = a;
	}
	scheduleResolve() {
		this.state = "scheduled", this.isAsync ? (Zn.add(this), Qn || (Qn = !0, N.read(nr), N.resolveKeyframes(tr))) : (this.readKeyframes(), this.complete());
	}
	readKeyframes() {
		let { unresolvedKeyframes: e, name: t, element: n, motionValue: r } = this;
		if (e[0] === null) {
			let i = r?.get(), a = e[e.length - 1];
			if (i !== void 0) e[0] = i;
			else if (n && t) {
				let r = n.readValue(t, a);
				r != null && (e[0] = r);
			}
			e[0] === void 0 && (e[0] = a), r && i === void 0 && r.set(e[0]);
		}
		Mn(e);
	}
	setFinalKeyframe() {}
	measureInitialState() {}
	renderEndStyles() {}
	measureEndState() {}
	complete(e = !1) {
		this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Zn.delete(this);
	}
	cancel() {
		this.state === "scheduled" && (Zn.delete(this), this.state = "pending");
	}
	resume() {
		this.state === "pending" && this.scheduleResolve();
	}
}, ar = (e) => e.startsWith("--");
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/dom/style-set.mjs
function or(e, t, n) {
	ar(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/supports/flags.mjs
var sr = {};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/supports/memo.mjs
function cr(e, t) {
	let n = /* @__PURE__ */ fe(e);
	return () => sr[t] ?? n();
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/supports/scroll-timeline.mjs
var lr = /* @__PURE__ */ cr(() => window.ScrollTimeline !== void 0, "scrollTimeline"), ur = /*@__PURE__*/ cr(() => {
	try {
		document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
	} catch {
		return !1;
	}
	return !0;
}, "linearEasing"), dr = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, fr = {
	linear: "linear",
	ease: "ease",
	easeIn: "ease-in",
	easeOut: "ease-out",
	easeInOut: "ease-in-out",
	circIn: /*@__PURE__*/ dr([
		0,
		.65,
		.55,
		1
	]),
	circOut: /*@__PURE__*/ dr([
		.55,
		0,
		1,
		.45
	]),
	backIn: /*@__PURE__*/ dr([
		.31,
		.01,
		.66,
		-.59
	]),
	backOut: /*@__PURE__*/ dr([
		.33,
		1.53,
		.69,
		.99
	])
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/waapi/easing/map-easing.mjs
function pr(e, t) {
	if (e) return typeof e == "function" ? ur() ? en(e, t) : "ease-out" : /* @__PURE__ */ ze(e) ? dr(e) : Array.isArray(e) ? e.map((e) => pr(e, t) || fr.easeOut) : fr[e];
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/waapi/start-waapi-animation.mjs
function mr(e, t, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s = "easeOut", times: c } = {}, l = void 0) {
	let u = { [t]: n };
	c && (u.offset = c);
	let d = pr(s, i);
	Array.isArray(d) && (u.easing = d);
	let f = {
		delay: r,
		duration: i,
		easing: Array.isArray(d) ? "linear" : d,
		fill: "both",
		iterations: a + 1,
		direction: o === "reverse" ? "alternate" : "normal"
	};
	return l && (f.pseudoElement = l), e.animate(u, f);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/generators/utils/is-generator.mjs
function hr(e) {
	return typeof e == "function" && "applyToOptions" in e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/waapi/utils/apply-generator.mjs
function gr({ type: e, ...t }) {
	return hr(e) && ur() ? e.applyToOptions(t) : (t.duration ??= 300, t.ease ??= "easeOut", t);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/NativeAnimation.mjs
var _r = class extends kn {
	constructor(e) {
		if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !e) return;
		let { element: t, name: n, keyframes: r, pseudoElement: i, allowFlatten: a = !1, finalKeyframe: o, onComplete: s } = e;
		this.isPseudoElement = !!i, this.allowFlatten = a, this.options = e, O(typeof e.type != "string", "Mini animate() doesn't support \"type\" as a string.", "mini-spring");
		let c = gr(e);
		this.animation = mr(t, n, r, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
			if (this.finishedTime = this.time, !i) {
				let e = En(r, this.options, o, this.speed);
				this.updateMotionValue && this.updateMotionValue(e), or(t, n, e), this.animation.cancel();
			}
			s?.(), this.notifyFinished();
		};
	}
	play() {
		this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
	}
	pause() {
		this.animation.pause();
	}
	complete() {
		this.animation.finish?.();
	}
	cancel() {
		try {
			this.animation.cancel();
		} catch {}
	}
	stop() {
		if (this.isStopped) return;
		this.isStopped = !0;
		let { state: e } = this;
		e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
	}
	commitStyles() {
		let e = this.options?.element;
		!this.isPseudoElement && e?.isConnected && this.animation.commitStyles?.();
	}
	get duration() {
		let e = this.animation.effect?.getComputedTiming?.().duration || 0;
		return /* @__PURE__ */ M(Number(e));
	}
	get iterationDuration() {
		let { delay: e = 0 } = this.options || {};
		return this.duration + /* @__PURE__ */ M(e);
	}
	get time() {
		return /* @__PURE__ */ M(Number(this.animation.currentTime) || 0);
	}
	set time(e) {
		let t = this.finishedTime !== null;
		this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ j(e), t && this.animation.pause();
	}
	get speed() {
		return this.animation.playbackRate;
	}
	set speed(e) {
		e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
	}
	get state() {
		return this.finishedTime === null ? this.animation.playState : "finished";
	}
	get startTime() {
		return this.manualStartTime ?? Number(this.animation.startTime);
	}
	set startTime(e) {
		this.manualStartTime = this.animation.startTime = e;
	}
	attachTimeline({ timeline: e, rangeStart: t, rangeEnd: n, observe: r }) {
		return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, e && lr() ? (this.animation.timeline = e, t && (this.animation.rangeStart = t), n && (this.animation.rangeEnd = n), A) : r(this);
	}
}, vr = {
	anticipate: Ae,
	backInOut: ke,
	circInOut: Ne
};
function yr(e) {
	return e in vr;
}
function br(e) {
	typeof e.ease == "string" && yr(e.ease) && (e.ease = vr[e.ease]);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/NativeAnimationExtended.mjs
var xr = 10, Sr = class extends _r {
	constructor(e) {
		br(e), On(e), super(e), e.startTime !== void 0 && e.autoplay !== !1 && (this.startTime = e.startTime), this.options = e;
	}
	updateMotionValue(e) {
		let { motionValue: t, onUpdate: n, onComplete: r, element: i, ...a } = this.options;
		if (!t) return;
		if (e !== void 0) {
			t.set(e);
			return;
		}
		let o = new jn({
			...a,
			autoplay: !1
		}), s = Math.max(xr, I.now() - this.startTime), c = D(0, xr, s - xr), l = o.sample(s).value, { name: u } = this.options;
		i && u && or(i, u, l), t.setWithVelocity(o.sample(Math.max(0, s - c)).value, l, c), o.stop();
	}
}, Cr = (e, t) => t !== "zIndex" && !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && (V.test(e) || e === "0") && !e.startsWith("url("));
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/can-animate.mjs
function wr(e) {
	let t = e[0];
	if (e.length === 1) return !0;
	for (let n = 0; n < e.length; n++) if (e[n] !== t) return !0;
}
function Tr(e, t, n, r) {
	let i = e[0];
	if (i === null) return !1;
	if (t === "display" || t === "visibility") return !0;
	let a = e[e.length - 1], o = Cr(i, t), s = Cr(a, t);
	return ce(o === s, `You are trying to animate ${t} from "${i}" to "${a}". "${o ? a : i}" is not an animatable value.`, "value-not-animatable"), !o || !s ? !1 : wr(e) || (n === "spring" || hr(n)) && r;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/make-animation-instant.mjs
function Er(e) {
	e.duration = 0, e.type = "keyframes";
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/waapi/utils/accelerated-values.mjs
var Dr = /* @__PURE__ */ new Set([
	"opacity",
	"clipPath",
	"filter",
	"transform",
	"backgroundColor"
]), Or = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function kr(e) {
	for (let t = 0; t < e.length; t++) if (typeof e[t] == "string" && Or.test(e[t])) return !0;
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/waapi/supports/waapi.mjs
var Ar = /* @__PURE__ */ new Set([
	"color",
	"backgroundColor",
	"outlineColor",
	"fill",
	"stroke",
	"borderColor",
	"borderTopColor",
	"borderRightColor",
	"borderBottomColor",
	"borderLeftColor"
]), jr = /*@__PURE__*/ fe(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Mr(e) {
	let { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: a, type: o, keyframes: s } = e, c = t?.owner?.current;
	if (!(c instanceof HTMLElement) && !(c instanceof SVGElement)) return !1;
	let { onUpdate: l, transformTemplate: u } = t.owner.getProps();
	return jr() && n && (Dr.has(n) || Ar.has(n) && kr(s)) && (n !== "transform" || !u) && !l && !r && i !== "mirror" && a !== 0 && o !== "inertia";
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/AsyncMotionValueAnimation.mjs
var Nr = 40, Pr = class extends kn {
	constructor({ autoplay: e = !0, delay: t = 0, type: n = "keyframes", repeat: r = 0, repeatDelay: i = 0, repeatType: a = "loop", keyframes: o, name: s, motionValue: c, element: l, ...u }) {
		super(), this.stop = () => {
			this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
		}, this.createdAt = I.now();
		let d = {
			autoplay: e,
			delay: t,
			type: n,
			repeat: r,
			repeatDelay: i,
			repeatType: a,
			name: s,
			motionValue: c,
			element: l,
			...u
		}, f = l?.KeyframeResolver || ir;
		this.keyframeResolver = new f(o, (e, t, n) => this.onKeyframesResolved(e, t, d, !n), s, c, l), this.keyframeResolver?.scheduleResolve();
	}
	onKeyframesResolved(e, t, n, r) {
		this.keyframeResolver = void 0;
		let { name: i, type: a, velocity: o, delay: s, isHandoff: c, onUpdate: l } = n;
		this.resolvedAt = I.now();
		let u = !0;
		Tr(e, i, a, o) || (u = !1, (k.instantAnimations || !s) && l?.(En(e, n, t)), e[0] = e[e.length - 1], Er(n), n.repeat = 0);
		let d = {
			startTime: r ? this.resolvedAt && this.resolvedAt - this.createdAt > Nr ? this.resolvedAt : this.createdAt : void 0,
			finalKeyframe: t,
			...n,
			keyframes: e
		}, f = u && !c && Mr(d), p = d.motionValue?.owner?.current, m;
		if (f) try {
			m = new Sr({
				...d,
				element: p
			});
		} catch {
			m = new jn(d);
		}
		else m = new jn(d);
		m.finished.then(() => {
			this.notifyFinished();
		}).catch(A), this.pendingTimeline &&= (this.stopTimeline = m.attachTimeline(this.pendingTimeline), void 0), this._animation = m;
	}
	get finished() {
		return this._animation ? this.animation.finished : this._finished;
	}
	then(e, t) {
		return this.finished.finally(e).then(() => {});
	}
	get animation() {
		return this._animation || (this.keyframeResolver?.resume(), rr()), this._animation;
	}
	get duration() {
		return this.animation.duration;
	}
	get iterationDuration() {
		return this.animation.iterationDuration;
	}
	get time() {
		return this.animation.time;
	}
	set time(e) {
		this.animation.time = e;
	}
	get speed() {
		return this.animation.speed;
	}
	get state() {
		return this.animation.state;
	}
	set speed(e) {
		this.animation.speed = e;
	}
	get startTime() {
		return this.animation.startTime;
	}
	attachTimeline(e) {
		return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
	}
	play() {
		this.animation.play();
	}
	pause() {
		this.animation.pause();
	}
	complete() {
		this.animation.complete();
	}
	cancel() {
		this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
	}
}, Fr = class {
	constructor(e) {
		this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
	}
	get finished() {
		return Promise.all(this.animations.map((e) => e.finished));
	}
	getAll(e) {
		return this.animations[0][e];
	}
	setAll(e, t) {
		for (let n = 0; n < this.animations.length; n++) this.animations[n][e] = t;
	}
	attachTimeline(e) {
		let t = this.animations.map((t) => t.attachTimeline(e));
		return () => {
			t.forEach((e, t) => {
				e && e(), this.animations[t].stop();
			});
		};
	}
	get time() {
		return this.getAll("time");
	}
	set time(e) {
		this.setAll("time", e);
	}
	get speed() {
		return this.getAll("speed");
	}
	set speed(e) {
		this.setAll("speed", e);
	}
	get state() {
		return this.getAll("state");
	}
	get startTime() {
		return this.getAll("startTime");
	}
	get duration() {
		return Ir(this.animations, "duration");
	}
	get iterationDuration() {
		return Ir(this.animations, "iterationDuration");
	}
	runAll(e) {
		this.animations.forEach((t) => t[e]());
	}
	play() {
		this.runAll("play");
	}
	pause() {
		this.runAll("pause");
	}
	cancel() {
		this.runAll("cancel");
	}
	complete() {
		this.runAll("complete");
	}
};
function Ir(e, t) {
	let n = 0;
	for (let r = 0; r < e.length; r++) {
		let i = e[r][t];
		i !== null && i > n && (n = i);
	}
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/GroupAnimationWithThen.mjs
var Lr = class extends Fr {
	then(e, t) {
		return this.finished.finally(e).then(() => {});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/calc-child-stagger.mjs
function Rr(e, t, n, r = 0, i = 1) {
	let a = Array.from(e).sort((e, t) => e.sortNodePosition(t)).indexOf(t), o = e.size, s = (o - 1) * r;
	return typeof n == "function" ? n(a, o) : i === 1 ? a * r : s - a * r;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/index.mjs
var zr = 30, Br = (e) => !isNaN(parseFloat(e)), Vr = { current: void 0 }, Hr = class {
	constructor(e, t = {}) {
		this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (e) => {
			let t = I.now();
			if (this.updatedAt !== t && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(e), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents)) for (let e of this.dependents) e.dirty();
		}, this.hasAnimated = !1, this.setCurrent(e), this.owner = t.owner;
	}
	setCurrent(e) {
		this.current = e, this.updatedAt = I.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Br(this.current));
	}
	setPrevFrameValue(e = this.current) {
		this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
	}
	onChange(e) {
		return process.env.NODE_ENV !== "production" && ve(!1, "value.onChange(callback) is deprecated. Switch to value.on(\"change\", callback)."), this.on("change", e);
	}
	on(e, t) {
		this.events[e] || (this.events[e] = new he());
		let n = this.events[e].add(t);
		return e === "change" ? () => {
			n(), N.read(() => {
				this.events.change.getSize() || this.stop();
			});
		} : n;
	}
	clearListeners() {
		for (let e in this.events) this.events[e].clear();
	}
	attach(e, t) {
		this.passiveEffect = e, this.stopPassiveEffect = t;
	}
	set(e) {
		this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
	}
	setWithVelocity(e, t, n) {
		this.set(t), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - n;
	}
	jump(e, t = !0) {
		this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, t && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
	}
	dirty() {
		this.events.change?.notify(this.current);
	}
	addDependent(e) {
		this.dependents ||= /* @__PURE__ */ new Set(), this.dependents.add(e);
	}
	removeDependent(e) {
		this.dependents && this.dependents.delete(e);
	}
	get() {
		return Vr.current && Vr.current.push(this), this.current;
	}
	getPrevious() {
		return this.prev;
	}
	getVelocity() {
		let e = I.now();
		if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > zr) return 0;
		let t = Math.min(this.updatedAt - this.prevUpdatedAt, zr);
		return /* @__PURE__ */ ge(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
	}
	start(e) {
		return this.stop(), new Promise((t) => {
			this.hasAnimated = !0, this.animation = e(t), this.events.animationStart && this.events.animationStart.notify();
		}).then(() => {
			this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
		});
	}
	stop() {
		this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
	}
	isAnimating() {
		return !!this.animation;
	}
	clearAnimation() {
		delete this.animation;
	}
	destroy() {
		this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
	}
};
function G(e, t) {
	return new Hr(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/resolve-transition.mjs
function Ur(e, t) {
	if (e?.inherit && t) {
		let { inherit: n, ...r } = e;
		return {
			...t,
			...r
		};
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/get-value-transition.mjs
function Wr(e, t) {
	let n = e?.[t] ?? e?.default ?? e;
	return n === e ? n : Ur(n, e);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/utils/default-transitions.mjs
var Gr = {
	type: "spring",
	stiffness: 500,
	damping: 25,
	restSpeed: 10
}, Kr = (e) => ({
	type: "spring",
	stiffness: 550,
	damping: e === 0 ? 2 * Math.sqrt(550) : 30,
	restSpeed: 10
}), qr = {
	type: "keyframes",
	duration: .8
}, Jr = {
	type: "keyframes",
	ease: [
		.25,
		.1,
		.35,
		1
	],
	duration: .3
}, Yr = (e, { keyframes: t }) => t.length > 2 ? qr : Kn.has(e) ? e.startsWith("scale") ? Kr(t[1]) : Gr : Jr, Xr = /* @__PURE__ */ new Set([
	"when",
	"delay",
	"delayChildren",
	"staggerChildren",
	"staggerDirection",
	"repeat",
	"repeatType",
	"repeatDelay",
	"from",
	"elapsed"
]);
function Zr(e) {
	for (let t in e) if (!Xr.has(t)) return !0;
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/interfaces/motion-value.mjs
var Qr = (e, t, n, r = {}, i, a) => (o) => {
	let s = Wr(r, e) || {}, c = s.delay || r.delay || 0, { elapsed: l = 0 } = r;
	l -= /* @__PURE__ */ j(c);
	let u = {
		keyframes: Array.isArray(n) ? n : [null, n],
		ease: "easeOut",
		velocity: t.getVelocity(),
		...s,
		delay: -l,
		onUpdate: (e) => {
			t.set(e), s.onUpdate && s.onUpdate(e);
		},
		onComplete: () => {
			o(), s.onComplete && s.onComplete();
		},
		name: e,
		motionValue: t,
		element: a ? void 0 : i
	};
	Zr(s) || Object.assign(u, Yr(e, u)), u.duration &&= /* @__PURE__ */ j(u.duration), u.repeatDelay &&= /* @__PURE__ */ j(u.repeatDelay), u.from !== void 0 && (u.keyframes[0] = u.from);
	let d = !1;
	if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (Er(u), u.delay === 0 && (d = !0)), (k.instantAnimations || k.skipAnimations || i?.shouldSkipAnimations || s.skipAnimations) && (d = !0, Er(u), u.delay = 0), u.allowFlatten = !s.type && !s.ease, d && !a && t.get() !== void 0) {
		let e = En(u.keyframes, s);
		if (e !== void 0) {
			N.update(() => {
				u.onUpdate(e), u.onComplete();
			});
			return;
		}
	}
	return s.isSync ? new jn(u) : new Pr(u);
}, $r = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function ei(e) {
	let t = $r.exec(e);
	if (!t) return [,];
	let [, n, r, i] = t;
	return [`--${n ?? r}`, i];
}
var ti = 4;
function ni(e, t, n = 1) {
	O(n <= ti, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
	let [r, i] = ei(e);
	if (!r) return;
	let a = window.getComputedStyle(t).getPropertyValue(r);
	if (a) {
		let e = a.trim();
		return le(e) ? parseFloat(e) : e;
	}
	return $e(i) ? ni(i, t, n + 1) : i;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/resolve-variants.mjs
function ri(e) {
	let t = [{}, {}];
	return e?.values.forEach((e, n) => {
		t[0][n] = e.get(), t[1][n] = e.getVelocity();
	}), t;
}
function ii(e, t, n, r) {
	if (typeof t == "function") {
		let [i, a] = ri(r);
		t = t(n === void 0 ? e.custom : n, i, a);
	}
	if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
		let [i, a] = ri(r);
		t = t(n === void 0 ? e.custom : n, i, a);
	}
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/resolve-dynamic-variants.mjs
function ai(e, t, n) {
	let r = e.getProps();
	return ii(r, t, n === void 0 ? r.custom : n, e);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/keys-position.mjs
var oi = /* @__PURE__ */ new Set([
	"width",
	"height",
	"top",
	"left",
	"right",
	"bottom",
	...Gn
]), si = (e) => Array.isArray(e);
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/setters.mjs
function ci(e, t, n) {
	e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, G(n));
}
function li(e) {
	return si(e) ? e[e.length - 1] || 0 : e;
}
function ui(e, t) {
	let { transitionEnd: n = {}, transition: r = {}, ...i } = ai(e, t) || {};
	i = {
		...i,
		...n
	};
	for (let t in i) ci(e, t, li(i[t]));
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/utils/is-motion-value.mjs
var K = (e) => !!(e && e.getVelocity);
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/will-change/is.mjs
function di(e) {
	return !!(K(e) && e.add);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/will-change/add-will-change.mjs
function fi(e, t) {
	let n = e.getValue("willChange");
	if (di(n)) return n.add(t);
	if (!n && k.WillChange) {
		let n = new k.WillChange("auto");
		e.addValue("willChange", n), n.add(t);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/dom/utils/camel-to-dash.mjs
function pi(e) {
	return e.replace(/([A-Z])/g, (e) => `-${e.toLowerCase()}`);
}
var mi = "data-" + pi("framerAppearId");
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/optimized-appear/get-appear-id.mjs
function hi(e) {
	return e.props[mi];
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/interfaces/visual-element-target.mjs
function gi({ protectedKeys: e, needsAnimating: t }, n) {
	let r = e.hasOwnProperty(n) && t[n] !== !0;
	return t[n] = !1, r;
}
function _i(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
	let { transition: a, transitionEnd: o, ...s } = t, c = e.getDefaultTransition();
	a = a ? Ur(a, c) : c;
	let l = a?.reduceMotion, u = a?.skipAnimations;
	r && (a = r);
	let d = [], f = i && e.animationState && e.animationState.getState()[i], p = a?.path;
	p && p.animateVisualElement(e, s, a, n, d);
	for (let t in s) {
		let r = e.getValue(t, e.latestValues[t] ?? null), i = s[t];
		if (i === void 0 || f && gi(f, t)) continue;
		let o = {
			delay: n,
			...Wr(a || {}, t)
		};
		u && (o.skipAnimations = !0);
		let c = r.get();
		if (c !== void 0 && !r.isAnimating() && !Array.isArray(i) && i === c && !o.velocity) {
			N.update(() => r.set(i));
			continue;
		}
		let p = !1;
		if (window.MotionHandoffAnimation) {
			let n = hi(e);
			if (n) {
				let e = window.MotionHandoffAnimation(n, t, N);
				e !== null && (o.startTime = e, p = !0);
			}
		}
		fi(e, t);
		let m = l ?? e.shouldReduceMotion;
		r.start(Qr(t, r, i, m && oi.has(t) ? { type: !1 } : o, e, p));
		let h = r.animation;
		h && d.push(h);
	}
	if (o) {
		let t = () => N.update(() => {
			o && ui(e, o);
		});
		d.length ? Promise.all(d).then(t) : t();
	}
	return d;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/interfaces/visual-element-variant.mjs
function vi(e, t, n = {}) {
	let r = ai(e, t, n.type === "exit" ? e.presenceContext?.custom : void 0), { transition: i = e.getDefaultTransition() || {} } = r || {};
	n.transitionOverride && (i = n.transitionOverride);
	let a = r ? () => Promise.all(_i(e, r, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (r = 0) => {
		let { delayChildren: a = 0, staggerChildren: o, staggerDirection: s } = i;
		return yi(e, t, r, a, o, s, n);
	} : () => Promise.resolve(), { when: s } = i;
	if (s) {
		let [e, t] = s === "beforeChildren" ? [a, o] : [o, a];
		return e().then(() => t());
	} else return Promise.all([a(), o(n.delay)]);
}
function yi(e, t, n = 0, r = 0, i = 0, a = 1, o) {
	let s = [];
	for (let c of e.variantChildren) c.notify("AnimationStart", t), s.push(vi(c, t, {
		...o,
		delay: n + (typeof r == "function" ? 0 : r) + Rr(e.variantChildren, c, r, i, a)
	}).then(() => c.notify("AnimationComplete", t)));
	return Promise.all(s);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/interfaces/visual-element.mjs
function bi(e, t, n = {}) {
	e.notify("AnimationStart", t);
	let r;
	if (Array.isArray(t)) {
		let i = t.map((t) => vi(e, t, n));
		r = Promise.all(i);
	} else if (typeof t == "string") r = vi(e, t, n);
	else {
		let i = typeof t == "function" ? ai(e, t, n.custom) : t;
		r = Promise.all(_i(e, i, n));
	}
	return r.then(() => {
		e.notify("AnimationComplete", t);
	});
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/auto.mjs
var xi = {
	test: (e) => e === "auto",
	parse: (e) => e
}, Si = (e) => (t) => t.test(e), Ci = [
	nt,
	z,
	R,
	L,
	vt,
	_t,
	xi
], wi = (e) => Ci.find(Si(e));
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/utils/is-none.mjs
function Ti(e) {
	return typeof e == "number" ? e === 0 : e === null || e === "none" || e === "0" || de(e);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/complex/filter.mjs
var Ei = /* @__PURE__ */ new Set([
	"brightness",
	"contrast",
	"saturate",
	"opacity"
]);
function Di(e) {
	let [t, n] = e.slice(0, -1).split("(");
	if (t === "drop-shadow") return e;
	let [r] = n.match(ot) || [];
	if (!r) return e;
	let i = n.replace(r, ""), a = +!!Ei.has(t);
	return r !== n && (a *= 100), t + "(" + a + i + ")";
}
var Oi = /\b([a-z-]*)\(.*?\)/gu, ki = {
	...V,
	getAnimatableNone: (e) => {
		let t = e.match(Oi);
		return t ? t.map(Di).join(" ") : e;
	}
}, Ai = {
	...V,
	getAnimatableNone: (e) => {
		let t = V.parse(e);
		return V.createTransformer(e)(t.map((e) => typeof e == "number" ? 0 : typeof e == "object" ? {
			...e,
			alpha: 1
		} : e));
	}
}, ji = {
	...nt,
	transform: Math.round
}, Mi = {
	borderWidth: z,
	borderTopWidth: z,
	borderRightWidth: z,
	borderBottomWidth: z,
	borderLeftWidth: z,
	borderRadius: z,
	borderTopLeftRadius: z,
	borderTopRightRadius: z,
	borderBottomRightRadius: z,
	borderBottomLeftRadius: z,
	width: z,
	maxWidth: z,
	height: z,
	maxHeight: z,
	top: z,
	right: z,
	bottom: z,
	left: z,
	inset: z,
	insetBlock: z,
	insetBlockStart: z,
	insetBlockEnd: z,
	insetInline: z,
	insetInlineStart: z,
	insetInlineEnd: z,
	padding: z,
	paddingTop: z,
	paddingRight: z,
	paddingBottom: z,
	paddingLeft: z,
	paddingBlock: z,
	paddingBlockStart: z,
	paddingBlockEnd: z,
	paddingInline: z,
	paddingInlineStart: z,
	paddingInlineEnd: z,
	margin: z,
	marginTop: z,
	marginRight: z,
	marginBottom: z,
	marginLeft: z,
	marginBlock: z,
	marginBlockStart: z,
	marginBlockEnd: z,
	marginInline: z,
	marginInlineStart: z,
	marginInlineEnd: z,
	fontSize: z,
	backgroundPositionX: z,
	backgroundPositionY: z,
	rotate: L,
	pathRotation: L,
	rotateX: L,
	rotateY: L,
	rotateZ: L,
	scale: it,
	scaleX: it,
	scaleY: it,
	scaleZ: it,
	skew: L,
	skewX: L,
	skewY: L,
	distance: z,
	translateX: z,
	translateY: z,
	translateZ: z,
	x: z,
	y: z,
	z,
	perspective: z,
	transformPerspective: z,
	opacity: rt,
	originX: yt,
	originY: yt,
	originZ: z,
	zIndex: ji,
	fillOpacity: rt,
	strokeOpacity: rt,
	numOctaves: ji
}, Ni = {
	...Mi,
	color: B,
	backgroundColor: B,
	outlineColor: B,
	fill: B,
	stroke: B,
	borderColor: B,
	borderTopColor: B,
	borderRightColor: B,
	borderBottomColor: B,
	borderLeftColor: B,
	filter: ki,
	WebkitFilter: ki,
	mask: Ai,
	WebkitMask: Ai
}, Pi = (e) => Ni[e], Fi = /*@__PURE__*/ new Set([ki, Ai]);
function Ii(e, t) {
	let n = Pi(e);
	return Fi.has(n) || (n = V), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/utils/make-none-animatable.mjs
var Li = /* @__PURE__ */ new Set([
	"auto",
	"none",
	"0"
]);
function Ri(e, t, n) {
	let r = 0, i;
	for (; r < e.length && !i;) {
		let t = e[r];
		typeof t == "string" && !Li.has(t) && kt(t).values.length && (i = e[r]), r++;
	}
	if (i && n) for (let r of t) e[r] = Ii(n, i);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/keyframes/DOMKeyframesResolver.mjs
var zi = class extends ir {
	constructor(e, t, n, r, i) {
		super(e, t, n, r, i, !0);
	}
	readKeyframes() {
		let { unresolvedKeyframes: e, element: t, name: n } = this;
		if (!t || !t.current) return;
		super.readKeyframes();
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			if (typeof r == "string" && (r = r.trim(), $e(r))) {
				let i = ni(r, t.current);
				i !== void 0 && (e[n] = i), n === e.length - 1 && (this.finalKeyframe = r);
			}
		}
		if (this.resolveNoneKeyframes(), !oi.has(n) || e.length !== 2) return;
		let [r, i] = e, a = wi(r), o = wi(i);
		if (tt(r) !== tt(i) && W[n]) {
			this.needsMeasurement = !0;
			return;
		}
		if (a !== o) if (qn(a) && qn(o)) for (let t = 0; t < e.length; t++) {
			let n = e[t];
			typeof n == "string" && (e[t] = parseFloat(n));
		}
		else W[n] && (this.needsMeasurement = !0);
	}
	resolveNoneKeyframes() {
		let { unresolvedKeyframes: e, name: t } = this, n = [];
		for (let t = 0; t < e.length; t++) (e[t] === null || Ti(e[t])) && n.push(t);
		n.length && Ri(e, n, t);
	}
	measureInitialState() {
		let { element: e, unresolvedKeyframes: t, name: n } = this;
		if (!e || !e.current) return;
		n === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = W[n](e.measureViewportBox(), window.getComputedStyle(e.current)), t[0] = this.measuredOrigin;
		let r = t[t.length - 1];
		r !== void 0 && e.getValue(n, r).jump(r, !1);
	}
	measureEndState() {
		let { element: e, name: t, unresolvedKeyframes: n } = this;
		if (!e || !e.current) return;
		let r = e.getValue(t);
		r && r.jump(this.measuredOrigin, !1);
		let i = n.length - 1, a = n[i];
		n[i] = W[t](e.measureViewportBox(), window.getComputedStyle(e.current)), a !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = a), this.removedTransforms?.length && this.removedTransforms.forEach(([t, n]) => {
			e.getValue(t).set(n);
		}), this.resolveNoneKeyframes();
	}
}, Bi = [
	"borderTopLeftRadius",
	"borderTopRightRadius",
	"borderBottomRightRadius",
	"borderBottomLeftRadius"
];
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/resolve-elements.mjs
function Vi(e, t, n) {
	if (e == null) return [];
	if (e instanceof EventTarget) return [e];
	if (typeof e == "string") {
		let r = document;
		t && (r = t.current);
		let i = n?.[e] ?? r.querySelectorAll(e);
		return i ? Array.from(i) : [];
	}
	return Array.from(e).filter((e) => e != null);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/utils/get-as-type.mjs
var Hi = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/is-html-element.mjs
function Ui(e) {
	return ue(e) && "offsetHeight" in e && !("ownerSVGElement" in e);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/frameloop/microtask.mjs
var { schedule: Wi, cancel: Gi } = /* @__PURE__ */ Ke(queueMicrotask, !1), q = {
	x: !1,
	y: !1
};
function Ki() {
	return q.x || q.y;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/gestures/drag/state/set-active.mjs
function qi(e) {
	return e === "x" || e === "y" ? q[e] ? null : (q[e] = !0, () => {
		q[e] = !1;
	}) : q.x || q.y ? null : (q.x = q.y = !0, () => {
		q.x = q.y = !1;
	});
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/gestures/utils/setup.mjs
function Ji(e, t) {
	let n = Vi(e), r = new AbortController();
	return [
		n,
		{
			passive: !0,
			...t,
			signal: r.signal
		},
		() => r.abort()
	];
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/gestures/hover.mjs
function Yi(e) {
	return !(e.pointerType === "touch" || Ki());
}
function Xi(e, t, n = {}) {
	let [r, i, a] = Ji(e, n);
	return r.forEach((e) => {
		let n = !1, r = !1, a, o = () => {
			e.removeEventListener("pointerleave", u);
		}, s = (e) => {
			a &&= (a(e), void 0), o();
		}, c = (e) => {
			n = !1, window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", c), r && (r = !1, s(e));
		}, l = () => {
			n = !0, window.addEventListener("pointerup", c, i), window.addEventListener("pointercancel", c, i);
		}, u = (e) => {
			if (e.pointerType !== "touch") {
				if (n) {
					r = !0;
					return;
				}
				s(e);
			}
		};
		e.addEventListener("pointerenter", (n) => {
			if (!Yi(n)) return;
			r = !1;
			let o = t(e, n);
			typeof o == "function" && (a = o, e.addEventListener("pointerleave", u, i));
		}, i), e.addEventListener("pointerdown", l, i);
	}), a;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/gestures/utils/is-node-or-child.mjs
var Zi = (e, t) => t ? e === t || Zi(e, t.parentElement) : !1, Qi = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, $i = /* @__PURE__ */ new Set([
	"BUTTON",
	"INPUT",
	"SELECT",
	"TEXTAREA",
	"A"
]);
function ea(e) {
	return $i.has(e.tagName) || e.isContentEditable === !0;
}
var ta = /* @__PURE__ */ new Set([
	"INPUT",
	"SELECT",
	"TEXTAREA"
]);
function na(e) {
	return ta.has(e.tagName) || e.isContentEditable === !0;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/gestures/press/utils/state.mjs
var ra = /* @__PURE__ */ new WeakSet();
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/gestures/press/utils/keyboard.mjs
function ia(e) {
	return (t) => {
		t.key === "Enter" && e(t);
	};
}
function aa(e, t) {
	e.dispatchEvent(new PointerEvent("pointer" + t, {
		isPrimary: !0,
		bubbles: !0
	}));
}
var oa = (e, t) => {
	let n = e.currentTarget;
	if (!n) return;
	let r = ia(() => {
		if (ra.has(n)) return;
		aa(n, "down");
		let e = ia(() => {
			aa(n, "up");
		});
		n.addEventListener("keyup", e, t), n.addEventListener("blur", () => aa(n, "cancel"), t);
	});
	n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/gestures/press/index.mjs
function sa(e) {
	return Qi(e) && !Ki();
}
var ca = /* @__PURE__ */ new WeakSet();
function la(e, t, n = {}) {
	let [r, i, a] = Ji(e, n), o = (e) => {
		let r = e.currentTarget;
		if (!sa(e) || ca.has(e)) return;
		ra.add(r), n.stopPropagation && ca.add(e);
		let a = t(r, e), o = {
			...i,
			capture: !0
		}, s = (e, t) => {
			window.removeEventListener("pointerup", c, o), window.removeEventListener("pointercancel", l, o), ra.has(r) && ra.delete(r), sa(e) && typeof a == "function" && a(e, { success: t });
		}, c = (e) => {
			s(e, r === window || r === document || n.useGlobalTarget || Zi(r, e.target));
		}, l = (e) => {
			s(e, !1);
		};
		window.addEventListener("pointerup", c, o), window.addEventListener("pointercancel", l, o);
	};
	return r.forEach((e) => {
		(n.useGlobalTarget ? window : e).addEventListener("pointerdown", o, i), Ui(e) && (e.addEventListener("focus", (e) => oa(e, i)), !ea(e) && !e.hasAttribute("tabindex") && (e.tabIndex = 0));
	}), a;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/is-svg-element.mjs
function ua(e) {
	return ue(e) && "ownerSVGElement" in e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/resize/handle-element.mjs
var da = /* @__PURE__ */ new WeakMap(), fa, pa = (e, t, n) => (r, i) => i && i[0] ? i[0][e + "Size"] : ua(r) && "getBBox" in r ? r.getBBox()[t] : r[n], ma = /*@__PURE__*/ pa("inline", "width", "offsetWidth"), ha = /*@__PURE__*/ pa("block", "height", "offsetHeight");
function ga({ target: e, borderBoxSize: t }) {
	da.get(e)?.forEach((n) => {
		n(e, {
			get width() {
				return ma(e, t);
			},
			get height() {
				return ha(e, t);
			}
		});
	});
}
function _a(e) {
	e.forEach(ga);
}
function va() {
	typeof ResizeObserver > "u" || (fa = new ResizeObserver(_a));
}
function ya(e, t) {
	fa || va();
	let n = Vi(e);
	return n.forEach((e) => {
		let n = da.get(e);
		n || (n = /* @__PURE__ */ new Set(), da.set(e, n)), n.add(t), fa?.observe(e);
	}), () => {
		n.forEach((e) => {
			let n = da.get(e);
			n?.delete(t), n?.size || fa?.unobserve(e);
		});
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/resize/handle-window.mjs
var ba = /* @__PURE__ */ new Set(), xa;
function Sa() {
	xa = () => {
		let e = {
			get width() {
				return window.innerWidth;
			},
			get height() {
				return window.innerHeight;
			}
		};
		ba.forEach((t) => t(e));
	}, window.addEventListener("resize", xa);
}
function Ca(e) {
	return ba.add(e), xa || Sa(), () => {
		ba.delete(e), !ba.size && typeof xa == "function" && (window.removeEventListener("resize", xa), xa = void 0);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/resize/index.mjs
function wa(e, t) {
	return typeof e == "function" ? Ca(e) : ya(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/stats/buffer.mjs
var Ta = {
	value: null,
	addProjectionMetrics: null
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/is-svg-svg-element.mjs
function Ea(e) {
	return ua(e) && e.tagName === "svg";
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/types/utils/find.mjs
var Da = [
	...Ci,
	B,
	V
], Oa = (e) => Da.find(Si(e)), ka = () => ({
	translate: 0,
	scale: 1,
	origin: 0,
	originPoint: 0
}), Aa = () => ({
	x: ka(),
	y: ka()
}), ja = () => ({
	min: 0,
	max: 0
}), J = () => ({
	x: ja(),
	y: ja()
}), Ma = /* @__PURE__ */ new WeakMap();
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/is-animation-controls.mjs
function Na(e) {
	return typeof e == "object" && !!e && typeof e.start == "function";
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/is-variant-label.mjs
function Pa(e) {
	return typeof e == "string" || Array.isArray(e);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/variant-props.mjs
var Fa = [
	"animate",
	"whileInView",
	"whileFocus",
	"whileHover",
	"whileTap",
	"whileDrag",
	"exit"
], Ia = ["initial", ...Fa];
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/is-controlling-variants.mjs
function La(e) {
	return Na(e.animate) || Ia.some((t) => Pa(e[t]));
}
function Ra(e) {
	return !!(La(e) || e.variants);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/motion-values.mjs
function za(e, t, n) {
	for (let r in t) {
		let i = t[r], a = n[r];
		if (K(i)) e.addValue(r, i);
		else if (K(a)) e.addValue(r, G(i, { owner: e }));
		else if (a !== i) if (e.hasValue(r)) {
			let t = e.getValue(r);
			t.liveStyle === !0 ? t.jump(i) : t.hasAnimated || t.set(i);
		} else {
			let t = e.getStaticValue(r);
			e.addValue(r, G(t === void 0 ? i : t, { owner: e }));
		}
	}
	for (let r in n) t[r] === void 0 && e.removeValue(r);
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/reduced-motion/state.mjs
var Ba = { current: null }, Va = { current: !1 }, Ha = typeof window < "u";
function Ua() {
	if (Va.current = !0, Ha) if (window.matchMedia) {
		let e = window.matchMedia("(prefers-reduced-motion)"), t = () => Ba.current = e.matches;
		e.addEventListener("change", t), t();
	} else Ba.current = !1;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/VisualElement.mjs
var Wa = [
	"AnimationStart",
	"AnimationComplete",
	"Update",
	"BeforeLayoutMeasure",
	"LayoutMeasure",
	"LayoutAnimationStart",
	"LayoutAnimationComplete"
], Ga = {};
function Ka(e) {
	Ga = e;
}
function qa() {
	return Ga;
}
var Ja = class {
	scrapeMotionValuesFromProps(e, t, n) {
		return {};
	}
	constructor({ parent: e, props: t, presenceContext: n, reducedMotionConfig: r, skipAnimations: i, blockInitialAnimation: a, visualState: o }, s = {}) {
		this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = ir, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
			this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
		}, this.renderScheduledAt = 0, this.scheduleRender = () => {
			let e = I.now();
			this.renderScheduledAt < e && (this.renderScheduledAt = e, N.render(this.render, !1, !0));
		};
		let { latestValues: c, renderState: l } = o;
		this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = t.initial ? { ...c } : {}, this.renderState = l, this.parent = e, this.props = t, this.presenceContext = n, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = r, this.skipAnimationsConfig = i, this.options = s, this.blockInitialAnimation = !!a, this.isControllingVariants = La(t), this.isVariantNode = Ra(t), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
		let { willChange: u, ...d } = this.scrapeMotionValuesFromProps(t, {}, this);
		for (let e in d) {
			let t = d[e];
			c[e] !== void 0 && K(t) && t.set(c[e]);
		}
	}
	mount(e) {
		if (this.hasBeenMounted) for (let e in this.initialValues) this.values.get(e)?.jump(this.initialValues[e]), this.latestValues[e] = this.initialValues[e];
		this.current = e, Ma.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((e, t) => this.bindToMotionValue(t, e)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (Va.current || Ua(), this.shouldReduceMotion = Ba.current), process.env.NODE_ENV !== "production" && ve(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, this.parent?.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
	}
	unmount() {
		this.projection && this.projection.unmount(), P(this.notifyUpdate), P(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
		for (let e in this.events) this.events[e].clear();
		for (let e in this.features) {
			let t = this.features[e];
			t && (t.unmount(), t.isMounted = !1);
		}
		this.current = null;
	}
	addChild(e) {
		this.children.add(e), this.enteringChildren ??= /* @__PURE__ */ new Set(), this.enteringChildren.add(e);
	}
	removeChild(e) {
		this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
	}
	bindToMotionValue(e, t) {
		if (this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)(), t.accelerate && Dr.has(e) && this.current instanceof HTMLElement) {
			let { factory: n, keyframes: r, times: i, ease: a, duration: o } = t.accelerate, s = new _r({
				element: this.current,
				name: e,
				keyframes: r,
				times: i,
				ease: a,
				duration: /* @__PURE__ */ j(o)
			}), c = n(s);
			this.valueSubscriptions.set(e, () => {
				c(), s.cancel();
			});
			return;
		}
		let n = Kn.has(e);
		n && this.onBindTransform && this.onBindTransform();
		let r = t.on("change", (t) => {
			this.latestValues[e] = t, this.props.onUpdate && N.preRender(this.notifyUpdate), n && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
		}), i;
		typeof window < "u" && window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, e, t)), this.valueSubscriptions.set(e, () => {
			r(), i && i();
		});
	}
	sortNodePosition(e) {
		return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
	}
	updateFeatures() {
		let e = "animation";
		for (e in Ga) {
			let t = Ga[e];
			if (!t) continue;
			let { isEnabled: n, Feature: r } = t;
			if (!this.features[e] && r && n(this.props) && (this.features[e] = new r(this)), this.features[e]) {
				let t = this.features[e];
				t.isMounted ? t.update() : (t.mount(), t.isMounted = !0);
			}
		}
	}
	triggerBuild() {
		this.build(this.renderState, this.latestValues, this.props);
	}
	measureViewportBox() {
		return this.current ? this.measureInstanceViewportBox(this.current, this.props) : J();
	}
	getStaticValue(e) {
		return this.latestValues[e];
	}
	setStaticValue(e, t) {
		this.latestValues[e] = t;
	}
	update(e, t) {
		(e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
		for (let t = 0; t < Wa.length; t++) {
			let n = Wa[t];
			this.propEventSubscriptions[n] && (this.propEventSubscriptions[n](), delete this.propEventSubscriptions[n]);
			let r = e["on" + n];
			r && (this.propEventSubscriptions[n] = this.on(n, r));
		}
		this.prevMotionValues = za(this, this.scrapeMotionValuesFromProps(e, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
	}
	getProps() {
		return this.props;
	}
	getVariant(e) {
		return this.props.variants ? this.props.variants[e] : void 0;
	}
	getDefaultTransition() {
		return this.props.transition;
	}
	getTransformPagePoint() {
		return this.props.transformPagePoint;
	}
	getClosestVariantNode() {
		return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
	}
	addVariantChild(e) {
		let t = this.getClosestVariantNode();
		if (t) return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e);
	}
	addValue(e, t) {
		let n = this.values.get(e);
		t !== n && (n && this.removeValue(e), this.bindToMotionValue(e, t), this.values.set(e, t), this.latestValues[e] = t.get());
	}
	removeValue(e) {
		this.values.delete(e);
		let t = this.valueSubscriptions.get(e);
		t && (t(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
	}
	hasValue(e) {
		return this.values.has(e);
	}
	getValue(e, t) {
		if (this.props.values && this.props.values[e]) return this.props.values[e];
		let n = this.values.get(e);
		return n === void 0 && t !== void 0 && (n = G(t === null ? void 0 : t, { owner: this }), this.addValue(e, n)), n;
	}
	readValue(e, t) {
		let n = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
		return n != null && (typeof n == "string" && (le(n) || de(n)) ? n = parseFloat(n) : !Oa(n) && V.test(t) && (n = Ii(e, t)), this.setBaseTarget(e, K(n) ? n.get() : n)), K(n) ? n.get() : n;
	}
	setBaseTarget(e, t) {
		this.baseTarget[e] = t;
	}
	getBaseTarget(e) {
		let { initial: t } = this.props, n;
		if (typeof t == "string" || typeof t == "object") {
			let r = ii(this.props, t, this.presenceContext?.custom);
			r && (n = r[e]);
		}
		if (t && n !== void 0) return n;
		let r = this.getBaseTargetFromProps(this.props, e);
		return r !== void 0 && !K(r) ? r : this.initialValues[e] !== void 0 && n === void 0 ? void 0 : this.baseTarget[e];
	}
	on(e, t) {
		return this.events[e] || (this.events[e] = new he()), this.events[e].add(t);
	}
	notify(e, ...t) {
		this.events[e] && this.events[e].notify(...t);
	}
	scheduleRenderMicrotask() {
		Wi.render(this.render);
	}
}, Ya = class extends Ja {
	constructor() {
		super(...arguments), this.KeyframeResolver = zi;
	}
	sortInstanceNodePosition(e, t) {
		return e.compareDocumentPosition(t) & 2 ? 1 : -1;
	}
	getBaseTargetFromProps(e, t) {
		let n = e.style;
		return n ? n[t] : void 0;
	}
	removeValueFromRenderState(e, { vars: t, style: n }) {
		delete t[e], delete n[e];
	}
	handleChildMotionValue() {
		this.childSubscription && (this.childSubscription(), delete this.childSubscription);
		let { children: e } = this.props;
		K(e) && (this.childSubscription = e.on("change", (e) => {
			this.current && (this.current.textContent = `${e}`);
		}));
	}
}, Y = class {
	constructor(e) {
		this.isMounted = !1, this.node = e;
	}
	update() {}
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/geometry/conversion.mjs
function Xa({ top: e, left: t, right: n, bottom: r }) {
	return {
		x: {
			min: t,
			max: n
		},
		y: {
			min: e,
			max: r
		}
	};
}
function Za({ x: e, y: t }) {
	return {
		top: t.min,
		right: e.max,
		bottom: t.max,
		left: e.min
	};
}
function Qa(e, t) {
	if (!t) return e;
	let n = t({
		x: e.left,
		y: e.top
	}), r = t({
		x: e.right,
		y: e.bottom
	});
	return {
		top: n.y,
		left: n.x,
		bottom: r.y,
		right: r.x
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/utils/has-transform.mjs
function $a(e) {
	return e === void 0 || e === 1;
}
function eo({ scale: e, scaleX: t, scaleY: n }) {
	return !$a(e) || !$a(t) || !$a(n);
}
function to(e) {
	return eo(e) || no(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function no(e) {
	return ro(e.x) || ro(e.y);
}
function ro(e) {
	return e && e !== "0%";
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/geometry/delta-apply.mjs
function io(e, t, n) {
	return n + t * (e - n);
}
function ao(e, t, n, r, i) {
	return i !== void 0 && (e = io(e, i, r)), io(e, n, r) + t;
}
function oo(e, t = 0, n = 1, r, i) {
	e.min = ao(e.min, t, n, r, i), e.max = ao(e.max, t, n, r, i);
}
function so(e, { x: t, y: n }) {
	oo(e.x, t.translate, t.scale, t.originPoint), oo(e.y, n.translate, n.scale, n.originPoint);
}
var co = .999999999999, lo = 1.0000000000001;
function uo(e, t, n, r = !1) {
	let i = n.length;
	if (!i) return;
	t.x = t.y = 1;
	let a, o;
	for (let s = 0; s < i; s++) {
		a = n[s], o = a.projectionDelta;
		let { visualElement: i } = a.options;
		i && i.props.style && i.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && (X(e.x, -a.scroll.offset.x), X(e.y, -a.scroll.offset.y)), o && (t.x *= o.x.scale, t.y *= o.y.scale, so(e, o)), r && to(a.latestValues) && mo(e, a.latestValues, a.layout?.layoutBox));
	}
	t.x < lo && t.x > co && (t.x = 1), t.y < lo && t.y > co && (t.y = 1);
}
function X(e, t) {
	e.min += t, e.max += t;
}
function fo(e, t, n, r, i = .5) {
	oo(e, t, n, H(e.min, e.max, i), r);
}
function po(e, t) {
	return typeof e == "string" ? parseFloat(e) / 100 * (t.max - t.min) : e;
}
function mo(e, t, n) {
	let r = n ?? e;
	fo(e.x, po(t.x, r.x), t.scaleX, t.scale, t.originX), fo(e.y, po(t.y, r.y), t.scaleY, t.scale, t.originY);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/utils/measure.mjs
function ho(e, t) {
	return Xa(Qa(e.getBoundingClientRect(), t));
}
function go(e, t, n) {
	let r = ho(e, n), { scroll: i } = t;
	return i && (X(r.x, i.offset.x), X(r.y, i.offset.y)), r;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/html/utils/build-transform.mjs
var _o = {
	x: "translateX",
	y: "translateY",
	z: "translateZ",
	transformPerspective: "perspective"
}, vo = Gn.length;
function yo(e, t, n) {
	let r = "", i = !0;
	for (let a = 0; a < vo; a++) {
		let o = Gn[a], s = e[o];
		if (s === void 0) continue;
		let c = !0;
		if (typeof s == "number") c = s === +!!o.startsWith("scale");
		else {
			let e = parseFloat(s);
			c = o.startsWith("scale") ? e === 1 : e === 0;
		}
		if (!c || n) {
			let e = Hi(s, Mi[o]);
			if (!c) {
				i = !1;
				let t = _o[o] || o;
				r += `${t}(${e}) `;
			}
			n && (t[o] = e);
		}
	}
	let a = e.pathRotation;
	return a && (i = !1, r += `rotate(${Hi(a, Mi.pathRotation)}) `), r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/html/utils/build-styles.mjs
function bo(e, t, n) {
	let { style: r, vars: i, transformOrigin: a } = e, o = !1, s = !1;
	for (let e in t) {
		let n = t[e];
		if (Kn.has(e)) {
			o = !0;
			continue;
		} else if (Ze(e)) {
			i[e] = n;
			continue;
		} else {
			let t = Hi(n, Mi[e]);
			e.startsWith("origin") ? (s = !0, a[e] = t) : r[e] = t;
		}
	}
	if (t.transform || (o || n ? r.transform = yo(t, e.transform, n) : r.transform &&= "none"), s) {
		let { originX: e = "50%", originY: t = "50%", originZ: n = 0 } = a;
		r.transformOrigin = `${e} ${t} ${n}`;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/html/utils/render.mjs
function xo(e, { style: t, vars: n }, r, i) {
	let a = e.style, o;
	for (o in t) a[o] = t[o];
	for (o in i?.applyProjectionStyles(a, r), n) a.setProperty(o, n[o]);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/styles/scale-border-radius.mjs
function So(e, t) {
	return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
var Co = { correct: (e, t) => {
	if (!t.target) return e;
	if (typeof e == "string") if (z.test(e)) e = parseFloat(e);
	else return e;
	return `${So(e, t.target.x)}% ${So(e, t.target.y)}%`;
} }, wo = { correct: (e, { treeScale: t, projectionDelta: n }) => {
	let r = e, i = V.parse(e);
	if (i.length > 5) return r;
	let a = V.createTransformer(e), o = typeof i[0] == "number" ? 0 : 1, s = n.x.scale * t.x, c = n.y.scale * t.y;
	i[0 + o] /= s, i[1 + o] /= c;
	let l = H(s, c, .5);
	return typeof i[2 + o] == "number" && (i[2 + o] /= l), typeof i[3 + o] == "number" && (i[3 + o] /= l), a(i);
} }, To = {
	borderRadius: {
		...Co,
		applyTo: [...Bi]
	},
	borderTopLeftRadius: Co,
	borderTopRightRadius: Co,
	borderBottomLeftRadius: Co,
	borderBottomRightRadius: Co,
	boxShadow: wo
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/is-forced-motion-value.mjs
function Eo(e, { layout: t, layoutId: n }) {
	return Kn.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!To[e] || e === "opacity");
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/html/utils/scrape-motion-values.mjs
function Do(e, t, n) {
	let r = e.style, i = t?.style, a = {};
	if (!r) return a;
	for (let t in r) (K(r[t]) || i && K(i[t]) || Eo(t, e) || n?.getValue(t)?.liveStyle !== void 0) && (a[t] = r[t]);
	return a;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/html/HTMLVisualElement.mjs
function Oo(e) {
	return window.getComputedStyle(e);
}
var ko = class extends Ya {
	constructor() {
		super(...arguments), this.type = "html", this.renderInstance = xo;
	}
	mount(e) {
		O(!!e.style, "motion.create() components must forward their ref to a HTML or SVG element", "custom-component-ref"), super.mount(e);
	}
	readValueFromInstance(e, t) {
		if (Kn.has(t)) return this.projection?.isProjecting ? Vn(t) : Un(e, t);
		{
			let n = Oo(e), r = (Ze(t) ? n.getPropertyValue(t) : n[t]) || 0;
			return typeof r == "string" ? r.trim() : r;
		}
	}
	measureInstanceViewportBox(e, { transformPagePoint: t }) {
		return ho(e, t);
	}
	build(e, t, n) {
		bo(e, t, n.transformTemplate);
	}
	scrapeMotionValuesFromProps(e, t, n) {
		return Do(e, t, n);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/object/ObjectVisualElement.mjs
function Ao(e, t) {
	return e in t;
}
var jo = class extends Ja {
	constructor() {
		super(...arguments), this.type = "object";
	}
	readValueFromInstance(e, t) {
		if (Ao(t, e)) {
			let n = e[t];
			if (typeof n == "string" || typeof n == "number") return n;
		}
	}
	getBaseTargetFromProps() {}
	removeValueFromRenderState(e, t) {
		delete t.output[e];
	}
	measureInstanceViewportBox() {
		return J();
	}
	build(e, t) {
		Object.assign(e.output, t);
	}
	renderInstance(e, { output: t }) {
		Object.assign(e, t);
	}
	sortInstanceNodePosition() {
		return 0;
	}
}, Mo = {
	offset: "stroke-dashoffset",
	array: "stroke-dasharray"
}, No = {
	offset: "strokeDashoffset",
	array: "strokeDasharray"
};
function Po(e, t, n = 1, r = 0, i = !0) {
	e.pathLength = 1;
	let a = i ? Mo : No;
	e[a.offset] = `${-r}`, e[a.array] = `${t} ${n}`;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/svg/utils/build-attrs.mjs
var Fo = [
	"offsetDistance",
	"offsetPath",
	"offsetRotate",
	"offsetAnchor"
];
function Io(e, { attrX: t, attrY: n, attrScale: r, pathLength: i, pathSpacing: a = 1, pathOffset: o = 0, ...s }, c, l, u) {
	if (bo(e, s, l), c) {
		e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
		return;
	}
	e.attrs = e.style, e.style = {};
	let { attrs: d, style: f } = e;
	d.transform && (f.transform = d.transform, delete d.transform), (f.transform || d.transformOrigin) && (f.transformOrigin = d.transformOrigin ?? "50% 50%", delete d.transformOrigin), f.transform && (f.transformBox = u?.transformBox ?? "fill-box", delete d.transformBox);
	for (let e of Fo) d[e] !== void 0 && (f[e] = d[e], delete d[e]);
	t !== void 0 && (d.x = t), n !== void 0 && (d.y = n), r !== void 0 && (d.scale = r), i !== void 0 && Po(d, i, a, o, !1);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/svg/utils/camel-case-attrs.mjs
var Lo = /* @__PURE__ */ new Set([
	"baseFrequency",
	"diffuseConstant",
	"kernelMatrix",
	"kernelUnitLength",
	"keySplines",
	"keyTimes",
	"limitingConeAngle",
	"markerHeight",
	"markerWidth",
	"numOctaves",
	"targetX",
	"targetY",
	"surfaceScale",
	"specularConstant",
	"specularExponent",
	"stdDeviation",
	"tableValues",
	"viewBox",
	"gradientTransform",
	"pathLength",
	"startOffset",
	"textLength",
	"lengthAdjust"
]), Ro = (e) => typeof e == "string" && e.toLowerCase() === "svg";
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/svg/utils/render.mjs
function zo(e, t, n, r) {
	xo(e, t, void 0, r);
	for (let n in t.attrs) e.setAttribute(Lo.has(n) ? n : pi(n), t.attrs[n]);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/svg/utils/scrape-motion-values.mjs
function Bo(e, t, n) {
	let r = Do(e, t, n);
	for (let n in e) if (K(e[n]) || K(t[n])) {
		let t = Gn.indexOf(n) === -1 ? n : "attr" + n.charAt(0).toUpperCase() + n.substring(1);
		r[t] = e[n];
	}
	return r;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/svg/SVGVisualElement.mjs
var Vo = class extends Ya {
	constructor() {
		super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = J;
	}
	getBaseTargetFromProps(e, t) {
		return e[t];
	}
	readValueFromInstance(e, t) {
		if (Kn.has(t)) {
			let e = Pi(t);
			return e && e.default || 0;
		}
		return t = Lo.has(t) ? t : pi(t), e.getAttribute(t);
	}
	scrapeMotionValuesFromProps(e, t, n) {
		return Bo(e, t, n);
	}
	build(e, t, n) {
		Io(e, t, this.isSVGTag, n.transformTemplate, n.style);
	}
	renderInstance(e, t, n, r) {
		zo(e, t, n, r);
	}
	mount(e) {
		this.isSVGTag = Ro(e.tagName), super.mount(e);
	}
}, Ho = Ia.length;
function Uo(e) {
	if (!e) return;
	if (!e.isControllingVariants) {
		let t = e.parent && Uo(e.parent) || {};
		return e.props.initial !== void 0 && (t.initial = e.props.initial), t;
	}
	let t = {};
	for (let n = 0; n < Ho; n++) {
		let r = Ia[n], i = e.props[r];
		(Pa(i) || i === !1) && (t[r] = i);
	}
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/shallow-compare.mjs
function Wo(e, t) {
	if (!Array.isArray(t)) return !1;
	let n = t.length;
	if (n !== e.length) return !1;
	for (let r = 0; r < n; r++) if (t[r] !== e[r]) return !1;
	return !0;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/render/utils/animation-state.mjs
var Go = [...Fa].reverse(), Ko = Fa.length;
function qo(e) {
	return (t) => Promise.all(t.map(({ animation: t, options: n }) => bi(e, t, n)));
}
function Jo(e) {
	let t = qo(e), n = Zo(), r = !0, i = !1, a = (t) => (n, r) => {
		let i = ai(e, r, t === "exit" ? e.presenceContext?.custom : void 0);
		if (i) {
			let { transition: e, transitionEnd: t, ...r } = i;
			n = {
				...n,
				...r,
				...t
			};
		}
		return n;
	};
	function o(n) {
		t = n(e);
	}
	function s(o) {
		let { props: s } = e, c = Uo(e.parent) || {}, l = [], u = /* @__PURE__ */ new Set(), d = {}, f = Infinity;
		for (let t = 0; t < Ko; t++) {
			let p = Go[t], m = n[p], h = s[p] === void 0 ? c[p] : s[p], g = Pa(h), _ = p === o ? m.isActive : null;
			_ === !1 && (f = t);
			let v = h === c[p] && h !== s[p] && g;
			if (v && (r || i) && e.manuallyAnimateOnMount && (v = !1), m.protectedKeys = { ...d }, !m.isActive && _ === null || !h && !m.prevProp || Na(h) || typeof h == "boolean") continue;
			if (p === "exit" && m.isActive && _ !== !0) {
				m.prevResolvedValues && (d = {
					...d,
					...m.prevResolvedValues
				});
				continue;
			}
			let y = Yo(m.prevProp, h), b = y || p === o && m.isActive && !v && g || t > f && g, x = !1, S = Array.isArray(h) ? h : [h], C = S.reduce(a(p), {});
			_ === !1 && (C = {});
			let { prevResolvedValues: w = {} } = m, T = {
				...w,
				...C
			}, E = (t) => {
				b = !0, u.has(t) && (x = !0, u.delete(t)), m.needsAnimating[t] = !0;
				let n = e.getValue(t);
				n && (n.liveStyle = !1);
			};
			for (let e in T) {
				let t = C[e], n = w[e];
				if (d.hasOwnProperty(e)) continue;
				let r = !1;
				r = si(t) && si(n) ? !Wo(t, n) || y : t !== n, r ? t == null ? u.add(e) : E(e) : t !== void 0 && u.has(e) ? E(e) : m.protectedKeys[e] = !0;
			}
			m.prevProp = h, m.prevResolvedValues = C, m.isActive && (d = {
				...d,
				...C
			}), (r || i) && e.blockInitialAnimation && (b = !1);
			let ee = v && y;
			b && (!ee || x) && l.push(...S.map((t) => {
				let n = { type: p };
				if (typeof t == "string" && (r || i) && !ee && e.manuallyAnimateOnMount && e.parent) {
					let { parent: r } = e, i = ai(r, t);
					if (r.enteringChildren && i) {
						let { delayChildren: t } = i.transition || {};
						n.delay = Rr(r.enteringChildren, e, t);
					}
				}
				return {
					animation: t,
					options: n
				};
			}));
		}
		if (u.size) {
			let t = {};
			if (typeof s.initial != "boolean") {
				let n = ai(e, Array.isArray(s.initial) ? s.initial[0] : s.initial);
				n && n.transition && (t.transition = n.transition);
			}
			u.forEach((n) => {
				let r = e.getBaseTarget(n), i = e.getValue(n);
				i && (i.liveStyle = !0), t[n] = r ?? null;
			}), l.push({ animation: t });
		}
		let p = !!l.length;
		return r && (s.initial === !1 || s.initial === s.animate) && !e.manuallyAnimateOnMount && (p = !1), r = !1, i = !1, p ? t(l) : Promise.resolve();
	}
	function c(t, r) {
		if (n[t].isActive === r) return Promise.resolve();
		e.variantChildren?.forEach((e) => e.animationState?.setActive(t, r)), n[t].isActive = r;
		let i = s(t);
		for (let e in n) n[e].protectedKeys = {};
		return i;
	}
	return {
		animateChanges: s,
		setActive: c,
		setAnimateFunction: o,
		getState: () => n,
		reset: () => {
			n = Zo(), i = !0;
		}
	};
}
function Yo(e, t) {
	return typeof t == "string" ? t !== e : Array.isArray(t) ? !Wo(t, e) : !1;
}
function Xo(e = !1) {
	return {
		isActive: e,
		protectedKeys: {},
		needsAnimating: {},
		prevResolvedValues: {}
	};
}
function Zo() {
	return {
		animate: Xo(!0),
		whileInView: Xo(),
		whileHover: Xo(),
		whileTap: Xo(),
		whileDrag: Xo(),
		whileFocus: Xo(),
		exit: Xo()
	};
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/geometry/copy.mjs
function Qo(e, t) {
	e.min = t.min, e.max = t.max;
}
function Z(e, t) {
	Qo(e.x, t.x), Qo(e.y, t.y);
}
function $o(e, t) {
	e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/geometry/delta-calc.mjs
var es = .9999, ts = 1.0001, ns = -.01, rs = .01;
function Q(e) {
	return e.max - e.min;
}
function is(e, t, n) {
	return Math.abs(e - t) <= n;
}
function as(e, t, n, r = .5) {
	e.origin = r, e.originPoint = H(t.min, t.max, e.origin), e.scale = Q(n) / Q(t), e.translate = H(n.min, n.max, e.origin) - e.originPoint, (e.scale >= es && e.scale <= ts || isNaN(e.scale)) && (e.scale = 1), (e.translate >= ns && e.translate <= rs || isNaN(e.translate)) && (e.translate = 0);
}
function os(e, t, n, r) {
	as(e.x, t.x, n.x, r ? r.originX : void 0), as(e.y, t.y, n.y, r ? r.originY : void 0);
}
function ss(e, t, n, r = 0) {
	e.min = (r ? H(n.min, n.max, r) : n.min) + t.min, e.max = e.min + Q(t);
}
function cs(e, t, n, r) {
	ss(e.x, t.x, n.x, r?.x), ss(e.y, t.y, n.y, r?.y);
}
function ls(e, t, n, r = 0) {
	let i = r ? H(n.min, n.max, r) : n.min;
	e.min = t.min - i, e.max = e.min + Q(t);
}
function us(e, t, n, r) {
	ls(e.x, t.x, n.x, r?.x), ls(e.y, t.y, n.y, r?.y);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/geometry/delta-remove.mjs
function ds(e, t, n, r, i) {
	return e -= t, e = io(e, 1 / n, r), i !== void 0 && (e = io(e, 1 / i, r)), e;
}
function fs(e, t = 0, n = 1, r = .5, i, a = e, o = e) {
	if (R.test(t) && (t = parseFloat(t), t = H(o.min, o.max, t / 100) - o.min), typeof t != "number") return;
	let s = H(a.min, a.max, r);
	e === a && (s -= t), e.min = ds(e.min, t, n, s, i), e.max = ds(e.max, t, n, s, i);
}
function ps(e, t, [n, r, i], a, o) {
	fs(e, t[n], t[r], t[i], t.scale, a, o);
}
var ms = [
	"x",
	"scaleX",
	"originX"
], hs = [
	"y",
	"scaleY",
	"originY"
];
function gs(e, t, n, r) {
	ps(e.x, t, ms, n ? n.x : void 0, r ? r.x : void 0), ps(e.y, t, hs, n ? n.y : void 0, r ? r.y : void 0);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/geometry/utils.mjs
function _s(e) {
	return e.translate === 0 && e.scale === 1;
}
function vs(e) {
	return _s(e.x) && _s(e.y);
}
function ys(e, t) {
	return e.min === t.min && e.max === t.max;
}
function bs(e, t) {
	return ys(e.x, t.x) && ys(e.y, t.y);
}
function xs(e, t) {
	return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Ss(e, t) {
	return xs(e.x, t.x) && xs(e.y, t.y);
}
function Cs(e) {
	return Q(e.x) / Q(e.y);
}
function ws(e, t) {
	return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/utils/each-axis.mjs
function $(e) {
	return [e("x"), e("y")];
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/styles/transform.mjs
function Ts(e, t, n) {
	let r = "", i = e.x.translate / t.x, a = e.y.translate / t.y, o = n?.z || 0;
	if ((i || a || o) && (r = `translate3d(${i}px, ${a}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
		let { transformPerspective: e, rotate: t, pathRotation: i, rotateX: a, rotateY: o, skewX: s, skewY: c } = n;
		e && (r = `perspective(${e}px) ${r}`), t && (r += `rotate(${t}deg) `), i && (r += `rotate(${i}deg) `), a && (r += `rotateX(${a}deg) `), o && (r += `rotateY(${o}deg) `), s && (r += `skewX(${s}deg) `), c && (r += `skewY(${c}deg) `);
	}
	let s = e.x.scale * t.x, c = e.y.scale * t.y;
	return (s !== 1 || c !== 1) && (r += `scale(${s}, ${c})`), r || "none";
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/animation/mix-values.mjs
var Es = Bi.length, Ds = (e) => typeof e == "string" ? parseFloat(e) : e, Os = (e) => typeof e == "number" || z.test(e);
function ks(e, t, n, r, i, a) {
	i ? (e.opacity = H(0, n.opacity ?? 1, js(r)), e.opacityExit = H(t.opacity ?? 1, 0, Ms(r))) : a && (e.opacity = H(t.opacity ?? 1, n.opacity ?? 1, r));
	for (let i = 0; i < Es; i++) {
		let a = Bi[i], o = As(t, a), s = As(n, a);
		o === void 0 && s === void 0 || (o ||= 0, s ||= 0, o === 0 || s === 0 || Os(o) === Os(s) ? (e[a] = Math.max(H(Ds(o), Ds(s), r), 0), (R.test(s) || R.test(o)) && (e[a] += "%")) : e[a] = s);
	}
	(t.rotate || n.rotate) && (e.rotate = H(t.rotate || 0, n.rotate || 0, r));
}
function As(e, t) {
	return e[t] === void 0 ? e.borderRadius : e[t];
}
var js = /*@__PURE__*/ Ns(0, .5, Me), Ms = /*@__PURE__*/ Ns(.5, .95, A);
function Ns(e, t, n) {
	return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ me(e, t, r));
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/animation/animate/single-value.mjs
function Ps(e, t, n) {
	let r = K(e) ? e : G(e);
	return r.start(Qr("", r, t, n)), r.animation;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/events/add-dom-event.mjs
function Fs(e, t, n, r = { passive: !0 }) {
	return e.addEventListener(t, n, r), () => e.removeEventListener(t, n, r);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/utils/compare-by-depth.mjs
var Is = (e, t) => e.depth - t.depth, Ls = class {
	constructor() {
		this.children = [], this.isDirty = !1;
	}
	add(e) {
		ae(this.children, e), this.isDirty = !0;
	}
	remove(e) {
		oe(this.children, e), this.isDirty = !0;
	}
	forEach(e) {
		this.isDirty && this.children.sort(Is), this.isDirty = !1, this.children.forEach(e);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/utils/delay.mjs
function Rs(e, t) {
	let n = I.now(), r = ({ timestamp: i }) => {
		let a = i - n;
		a >= t && (P(r), e(a - t));
	};
	return N.setup(r, !0), () => P(r);
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/value/utils/resolve-motion-value.mjs
function zs(e) {
	return K(e) ? e.get() : e;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/shared/stack.mjs
var Bs = class {
	constructor() {
		this.members = [];
	}
	add(e) {
		ae(this.members, e);
		for (let t = this.members.length - 1; t >= 0; t--) {
			let n = this.members[t];
			if (n === e || n === this.lead || n === this.prevLead) continue;
			let r = n.instance;
			(!r || r.isConnected === !1) && !n.snapshot && (oe(this.members, n), n.unmount());
		}
		e.scheduleRender();
	}
	remove(e) {
		if (oe(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
			let e = this.members[this.members.length - 1];
			e && this.promote(e);
		}
	}
	relegate(e) {
		for (let t = this.members.indexOf(e) - 1; t >= 0; t--) {
			let e = this.members[t];
			if (e.isPresent !== !1 && e.instance?.isConnected !== !1) return this.promote(e), !0;
		}
		return !1;
	}
	promote(e, t) {
		let n = this.lead;
		if (e !== n && (this.prevLead = n, this.lead = e, e.show(), n)) {
			n.updateSnapshot(), e.scheduleRender();
			let { layoutDependency: r } = n.options, { layoutDependency: i } = e.options;
			(r === void 0 || r !== i) && (e.resumeFrom = n, t && (n.preserveOpacity = !0), n.snapshot && (e.snapshot = n.snapshot, e.snapshot.latestValues = n.animationValues || n.latestValues), e.root?.isUpdating && (e.isLayoutDirty = !0)), e.options.crossfade === !1 && n.hide();
		}
	}
	exitAnimationComplete() {
		this.members.forEach((e) => {
			e.options.onExitComplete?.(), e.resumingFrom?.options.onExitComplete?.();
		});
	}
	scheduleRender() {
		this.members.forEach((e) => e.instance && e.scheduleRender(!1));
	}
	removeLeadSnapshot() {
		this.lead?.snapshot && (this.lead.snapshot = void 0);
	}
}, Vs = {
	hasAnimatedSinceResize: !0,
	hasEverUpdated: !1
}, Hs = {
	nodes: 0,
	calculatedTargetDeltas: 0,
	calculatedProjections: 0
}, Us = [
	"",
	"X",
	"Y",
	"Z"
], Ws = 1e3, Gs = 0;
function Ks(e, t, n, r) {
	let { latestValues: i } = t;
	i[e] && (n[e] = i[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function qs(e) {
	if (e.hasCheckedOptimisedAppear = !0, e.root === e) return;
	let { visualElement: t } = e.options;
	if (!t) return;
	let n = hi(t);
	if (window.MotionHasOptimisedAnimation(n, "transform")) {
		let { layout: t, layoutId: r } = e.options;
		window.MotionCancelOptimisedAnimation(n, "transform", N, !(t || r));
	}
	let { parent: r } = e;
	r && !r.hasCheckedOptimisedAppear && qs(r);
}
function Js({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: i }) {
	return class {
		constructor(e = {}, n = t?.()) {
			this.id = Gs++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = {
				x: 1,
				y: 1
			}, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
				this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
			}, this.updateProjection = () => {
				this.projectionUpdateScheduled = !1, Ta.value && (Hs.nodes = Hs.calculatedTargetDeltas = Hs.calculatedProjections = 0), this.nodes.forEach(Zs), this.nodes.forEach(oc), this.nodes.forEach(sc), this.nodes.forEach(Qs), Ta.addProjectionMetrics && Ta.addProjectionMetrics(Hs);
			}, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = e, this.root = n ? n.root || n : this, this.path = n ? [...n.path, n] : [], this.parent = n, this.depth = n ? n.depth + 1 : 0;
			for (let e = 0; e < this.path.length; e++) this.path[e].shouldResetTransform = !0;
			this.root === this && (this.nodes = new Ls());
		}
		addEventListener(e, t) {
			return this.eventHandlers.has(e) || this.eventHandlers.set(e, new he()), this.eventHandlers.get(e).add(t);
		}
		notifyListeners(e, ...t) {
			let n = this.eventHandlers.get(e);
			n && n.notify(...t);
		}
		hasListeners(e) {
			return this.eventHandlers.has(e);
		}
		mount(t) {
			if (this.instance) return;
			this.isSVG = ua(t) && !Ea(t), this.instance = t;
			let { layoutId: n, layout: r, visualElement: i } = this.options;
			if (i && !i.current && i.mount(t), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (r || n) && (this.isLayoutDirty = !0), e) {
				let n, r = 0, i = () => this.root.updateBlockedByResize = !1;
				N.read(() => {
					r = window.innerWidth;
				}), e(t, () => {
					let e = window.innerWidth;
					e !== r && (r = e, this.root.updateBlockedByResize = !0, n && n(), n = Rs(i, 250), Vs.hasAnimatedSinceResize && (Vs.hasAnimatedSinceResize = !1, this.nodes.forEach(ac)));
				});
			}
			n && this.root.registerSharedNode(n, this), this.options.animate !== !1 && i && (n || r) && this.addEventListener("didUpdate", ({ delta: e, hasLayoutChanged: t, hasRelativeLayoutChanged: n, layout: r }) => {
				if (this.isTreeAnimationBlocked()) {
					this.target = void 0, this.relativeTarget = void 0;
					return;
				}
				let a = this.options.transition || i.getDefaultTransition() || mc, { onLayoutAnimationStart: o, onLayoutAnimationComplete: s } = i.getProps(), c = !this.targetLayout || !Ss(this.targetLayout, r), l = !t && n;
				if (this.options.layoutRoot || this.resumeFrom || l || t && (c || !this.currentAnimation)) {
					this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
					let t = {
						...Wr(a, "layout"),
						onPlay: o,
						onComplete: s
					};
					(i.shouldReduceMotion || this.options.layoutRoot) && (t.delay = 0, t.type = !1), this.startAnimation(t), this.setAnimationOrigin(e, l, t.path);
				} else t || ac(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
				this.targetLayout = r;
			});
		}
		unmount() {
			this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
			let e = this.getStack();
			e && e.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), P(this.updateProjection);
		}
		blockUpdate() {
			this.updateManuallyBlocked = !0;
		}
		unblockUpdate() {
			this.updateManuallyBlocked = !1;
		}
		isUpdateBlocked() {
			return this.updateManuallyBlocked || this.updateBlockedByResize;
		}
		isTreeAnimationBlocked() {
			return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
		}
		startUpdate() {
			this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(cc), this.animationId++);
		}
		getTransformTemplate() {
			let { visualElement: e } = this.options;
			return e && e.getProps().transformTemplate;
		}
		willUpdate(e = !0) {
			if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
				this.options.onExitComplete && this.options.onExitComplete();
				return;
			}
			if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && qs(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty) return;
			this.isLayoutDirty = !0;
			for (let e = 0; e < this.path.length; e++) {
				let t = this.path[e];
				t.shouldResetTransform = !0, (typeof t.latestValues.x == "string" || typeof t.latestValues.y == "string") && (t.isLayoutDirty = !0), t.updateScroll("snapshot"), t.options.layoutRoot && t.willUpdate(!1);
			}
			let { layoutId: t, layout: n } = this.options;
			if (t === void 0 && !n) return;
			let r = this.getTransformTemplate();
			this.prevTransformTemplateValue = r ? r(this.latestValues, "") : void 0, this.updateSnapshot(), e && this.notifyListeners("willUpdate");
		}
		update() {
			if (this.updateScheduled = !1, this.isUpdateBlocked()) {
				let e = this.updateBlockedByResize;
				this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), e && this.nodes.forEach(tc), this.nodes.forEach(ec);
				return;
			}
			if (this.animationId <= this.animationCommitId) {
				this.nodes.forEach(nc);
				return;
			}
			this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(rc), this.nodes.forEach(ic), this.nodes.forEach(Ys), this.nodes.forEach(Xs)) : this.nodes.forEach(nc), this.clearAllSnapshots();
			let e = I.now();
			F.delta = D(0, 1e3 / 60, e - F.timestamp), F.timestamp = e, F.isProcessing = !0, qe.update.process(F), qe.preRender.process(F), qe.render.process(F), F.isProcessing = !1;
		}
		didUpdate() {
			this.updateScheduled || (this.updateScheduled = !0, Wi.read(this.scheduleUpdate));
		}
		clearAllSnapshots() {
			this.nodes.forEach($s), this.sharedNodes.forEach(lc);
		}
		scheduleUpdateProjection() {
			this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, N.preRender(this.updateProjection, !1, !0));
		}
		scheduleCheckAfterUnmount() {
			N.postRender(() => {
				this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
			});
		}
		updateSnapshot() {
			this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Q(this.snapshot.measuredBox.x) && !Q(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
		}
		updateLayout() {
			if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)) return;
			if (this.resumeFrom && !this.resumeFrom.instance) for (let e = 0; e < this.path.length; e++) this.path[e].updateScroll();
			let e = this.layout;
			this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected ||= J(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
			let { visualElement: t } = this.options;
			t && t.notify("LayoutMeasure", this.layout.layoutBox, e ? e.layoutBox : void 0);
		}
		updateScroll(e = "measure") {
			let t = !!(this.options.layoutScroll && this.instance);
			if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === e && (t = !1), t && this.instance) {
				let t = r(this.instance);
				this.scroll = {
					animationId: this.root.animationId,
					phase: e,
					isRoot: t,
					offset: n(this.instance),
					wasRoot: this.scroll ? this.scroll.isRoot : t
				};
			}
		}
		resetTransform() {
			if (!i) return;
			let e = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, t = this.projectionDelta && !vs(this.projectionDelta), n = this.getTransformTemplate(), r = n ? n(this.latestValues, "") : void 0, a = r !== this.prevTransformTemplateValue;
			e && this.instance && (t || to(this.latestValues) || a) && (i(this.instance, r), this.shouldResetTransform = !1, this.scheduleRender());
		}
		measure(e = !0) {
			let t = this.measurePageBox(), n = this.removeElementScroll(t);
			return e && (n = this.removeTransform(n)), vc(n), {
				animationId: this.root.animationId,
				measuredBox: t,
				layoutBox: n,
				latestValues: {},
				source: this.id
			};
		}
		measurePageBox() {
			let { visualElement: e } = this.options;
			if (!e) return J();
			let t = e.measureViewportBox();
			if (!(this.scroll?.wasRoot || this.path.some(bc))) {
				let { scroll: e } = this.root;
				e && (X(t.x, e.offset.x), X(t.y, e.offset.y));
			}
			return t;
		}
		removeElementScroll(e) {
			let t = J();
			if (Z(t, e), this.scroll?.wasRoot) return t;
			for (let n = 0; n < this.path.length; n++) {
				let r = this.path[n], { scroll: i, options: a } = r;
				r !== this.root && i && a.layoutScroll && (i.wasRoot && Z(t, e), X(t.x, i.offset.x), X(t.y, i.offset.y));
			}
			return t;
		}
		applyTransform(e, t = !1, n) {
			let r = n || J();
			Z(r, e);
			for (let e = 0; e < this.path.length; e++) {
				let n = this.path[e];
				!t && n.options.layoutScroll && n.scroll && n !== n.root && (X(r.x, -n.scroll.offset.x), X(r.y, -n.scroll.offset.y)), to(n.latestValues) && mo(r, n.latestValues, n.layout?.layoutBox);
			}
			return to(this.latestValues) && mo(r, this.latestValues, this.layout?.layoutBox), r;
		}
		removeTransform(e) {
			let t = J();
			Z(t, e);
			for (let e = 0; e < this.path.length; e++) {
				let n = this.path[e];
				if (!to(n.latestValues)) continue;
				let r;
				n.instance && (eo(n.latestValues) && n.updateSnapshot(), r = J(), Z(r, n.measurePageBox())), gs(t, n.latestValues, n.snapshot?.layoutBox, r);
			}
			return to(this.latestValues) && gs(t, this.latestValues), t;
		}
		setTargetDelta(e) {
			this.targetDelta = e, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
		}
		setOptions(e) {
			this.options = {
				...this.options,
				...e,
				crossfade: e.crossfade === void 0 || e.crossfade
			};
		}
		clearMeasurements() {
			this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
		}
		forceRelativeParentToResolveTarget() {
			this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== F.timestamp && this.relativeParent.resolveTargetDelta(!0);
		}
		resolveTargetDelta(e = !1) {
			let t = this.getLead();
			this.isProjectionDirty ||= t.isProjectionDirty, this.isTransformDirty ||= t.isTransformDirty, this.isSharedProjectionDirty ||= t.isSharedProjectionDirty;
			let n = !!this.resumingFrom || this !== t;
			if (!(e || n && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize)) return;
			let { layout: r, layoutId: i } = this.options;
			if (!this.layout || !(r || i)) return;
			this.resolvedRelativeTargetAt = F.timestamp;
			let a = this.getClosestProjectingParent();
			a && this.linkedParentVersion !== a.layoutVersion && !a.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && a && a.layout ? this.createRelativeTarget(a, this.layout.layoutBox, a.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = J(), this.targetWithTransforms = J()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), cs(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : Z(this.target, this.layout.layoutBox), so(this.target, this.targetDelta)) : Z(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && a && !!a.resumingFrom == !!this.resumingFrom && !a.options.layoutScroll && a.target && this.animationProgress !== 1 ? this.createRelativeTarget(a, this.target, a.target) : this.relativeParent = this.relativeTarget = void 0), Ta.value && Hs.calculatedTargetDeltas++);
		}
		getClosestProjectingParent() {
			if (!(!this.parent || eo(this.parent.latestValues) || no(this.parent.latestValues))) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
		}
		isProjecting() {
			return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
		}
		createRelativeTarget(e, t, n) {
			this.relativeParent = e, this.linkedParentVersion = e.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = J(), this.relativeTargetOrigin = J(), us(this.relativeTargetOrigin, t, n, this.options.layoutAnchor || void 0), Z(this.relativeTarget, this.relativeTargetOrigin);
		}
		removeRelativeTarget() {
			this.relativeParent = this.relativeTarget = void 0;
		}
		calcProjection() {
			let e = this.getLead(), t = !!this.resumingFrom || this !== e, n = !0;
			if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (n = !1), t && (this.isSharedProjectionDirty || this.isTransformDirty) && (n = !1), this.resolvedRelativeTargetAt === F.timestamp && (n = !1), n) return;
			let { layout: r, layoutId: i } = this.options;
			if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(r || i)) return;
			Z(this.layoutCorrected, this.layout.layoutBox);
			let a = this.treeScale.x, o = this.treeScale.y;
			uo(this.layoutCorrected, this.treeScale, this.path, t), e.layout && !e.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (e.target = e.layout.layoutBox, e.targetWithTransforms = J());
			let { target: s } = e;
			if (!s) {
				this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
				return;
			}
			!this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : ($o(this.prevProjectionDelta.x, this.projectionDelta.x), $o(this.prevProjectionDelta.y, this.projectionDelta.y)), os(this.projectionDelta, this.layoutCorrected, s, this.latestValues), (this.treeScale.x !== a || this.treeScale.y !== o || !ws(this.projectionDelta.x, this.prevProjectionDelta.x) || !ws(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", s)), Ta.value && Hs.calculatedProjections++;
		}
		hide() {
			this.isVisible = !1;
		}
		show() {
			this.isVisible = !0;
		}
		scheduleRender(e = !0) {
			if (this.options.visualElement?.scheduleRender(), e) {
				let e = this.getStack();
				e && e.scheduleRender();
			}
			this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
		}
		createProjectionDeltas() {
			this.prevProjectionDelta = Aa(), this.projectionDelta = Aa(), this.projectionDeltaWithTransform = Aa();
		}
		setAnimationOrigin(e, t = !1, n) {
			let r = this.snapshot, i = r ? r.latestValues : {}, a = { ...this.latestValues }, o = Aa();
			(!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !t;
			let s = J(), c = (r ? r.source : void 0) !== (this.layout ? this.layout.source : void 0), l = this.getStack(), u = !l || l.members.length <= 1, d = !!(c && !u && this.options.crossfade === !0 && !this.path.some(pc));
			this.animationProgress = 0;
			let f, p = n?.interpolateProjection(e);
			this.mixTargetDelta = (t) => {
				let n = t / 1e3, r = p?.(n);
				r ? (o.x.translate = r.x, o.x.scale = H(e.x.scale, 1, n), o.x.origin = e.x.origin, o.x.originPoint = e.x.originPoint, o.y.translate = r.y, o.y.scale = H(e.y.scale, 1, n), o.y.origin = e.y.origin, o.y.originPoint = e.y.originPoint) : (uc(o.x, e.x, n), uc(o.y, e.y, n)), this.setTargetDelta(o), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (us(s, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), fc(this.relativeTarget, this.relativeTargetOrigin, s, n), f && bs(this.relativeTarget, f) && (this.isProjectionDirty = !1), f ||= J(), Z(f, this.relativeTarget)), c && (this.animationValues = a, ks(a, i, this.latestValues, n, d, u)), r && r.rotate !== void 0 && (this.animationValues ||= a, this.animationValues.pathRotation = r.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = n;
			}, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
		}
		startAnimation(e) {
			this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation &&= (P(this.pendingAnimation), void 0), this.pendingAnimation = N.update(() => {
				Vs.hasAnimatedSinceResize = !0, this.motionValue ||= G(0), this.motionValue.jump(0, !1), this.currentAnimation = Ps(this.motionValue, [0, 1e3], {
					...e,
					velocity: 0,
					isSync: !0,
					onUpdate: (t) => {
						this.mixTargetDelta(t), e.onUpdate && e.onUpdate(t);
					},
					onComplete: () => {
						e.onComplete && e.onComplete(), this.completeAnimation();
					}
				}), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
			});
		}
		completeAnimation() {
			this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
			let e = this.getStack();
			e && e.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
		}
		finishAnimation() {
			this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Ws), this.currentAnimation.stop()), this.completeAnimation();
		}
		applyTransformsToTarget() {
			let e = this.getLead(), { targetWithTransforms: t, target: n, layout: r, latestValues: i } = e;
			if (!(!t || !n || !r)) {
				if (this !== e && this.layout && r && yc(this.options.animationType, this.layout.layoutBox, r.layoutBox)) {
					n = this.target || J();
					let t = Q(this.layout.layoutBox.x);
					n.x.min = e.target.x.min, n.x.max = n.x.min + t;
					let r = Q(this.layout.layoutBox.y);
					n.y.min = e.target.y.min, n.y.max = n.y.min + r;
				}
				Z(t, n), mo(t, i), os(this.projectionDeltaWithTransform, this.layoutCorrected, t, i);
			}
		}
		registerSharedNode(e, t) {
			this.sharedNodes.has(e) || this.sharedNodes.set(e, new Bs()), this.sharedNodes.get(e).add(t);
			let n = t.options.initialPromotionConfig;
			t.promote({
				transition: n ? n.transition : void 0,
				preserveFollowOpacity: n && n.shouldPreserveFollowOpacity ? n.shouldPreserveFollowOpacity(t) : void 0
			});
		}
		isLead() {
			let e = this.getStack();
			return !e || e.lead === this;
		}
		getLead() {
			let { layoutId: e } = this.options;
			return e && this.getStack()?.lead || this;
		}
		getPrevLead() {
			let { layoutId: e } = this.options;
			return e ? this.getStack()?.prevLead : void 0;
		}
		getStack() {
			let { layoutId: e } = this.options;
			if (e) return this.root.sharedNodes.get(e);
		}
		promote({ needsReset: e, transition: t, preserveFollowOpacity: n } = {}) {
			let r = this.getStack();
			r && r.promote(this, n), e && (this.projectionDelta = void 0, this.needsReset = !0), t && this.setOptions({ transition: t });
		}
		relegate() {
			let e = this.getStack();
			return e ? e.relegate(this) : !1;
		}
		resetSkewAndRotation() {
			let { visualElement: e } = this.options;
			if (!e) return;
			let t = !1, { latestValues: n } = e;
			if ((n.z || n.rotate || n.rotateX || n.rotateY || n.rotateZ || n.skewX || n.skewY) && (t = !0), !t) return;
			let r = {};
			n.z && Ks("z", e, r, this.animationValues);
			for (let t = 0; t < Us.length; t++) Ks(`rotate${Us[t]}`, e, r, this.animationValues), Ks(`skew${Us[t]}`, e, r, this.animationValues);
			e.render();
			for (let t in r) e.setStaticValue(t, r[t]), this.animationValues && (this.animationValues[t] = r[t]);
			e.scheduleRender();
		}
		applyProjectionStyles(e, t) {
			if (!this.instance || this.isSVG) return;
			if (!this.isVisible) {
				e.visibility = "hidden";
				return;
			}
			let n = this.getTransformTemplate();
			if (this.needsReset) {
				this.needsReset = !1, e.visibility = "", e.opacity = "", e.pointerEvents = zs(t?.pointerEvents) || "", e.transform = n ? n(this.latestValues, "") : "none";
				return;
			}
			let r = this.getLead();
			if (!this.projectionDelta || !this.layout || !r.target) {
				this.options.layoutId && (e.opacity = this.latestValues.opacity === void 0 ? 1 : this.latestValues.opacity, e.pointerEvents = zs(t?.pointerEvents) || ""), this.hasProjected && !to(this.latestValues) && (e.transform = n ? n({}, "") : "none", this.hasProjected = !1);
				return;
			}
			e.visibility = "";
			let i = r.animationValues || r.latestValues;
			this.applyTransformsToTarget();
			let a = Ts(this.projectionDeltaWithTransform, this.treeScale, i);
			n && (a = n(i, a)), e.transform = a;
			let { x: o, y: s } = this.projectionDelta;
			e.transformOrigin = `${o.origin * 100}% ${s.origin * 100}% 0`, r.animationValues ? e.opacity = r === this ? i.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : i.opacityExit : e.opacity = r === this ? i.opacity === void 0 ? "" : i.opacity : i.opacityExit === void 0 ? 0 : i.opacityExit;
			for (let t in To) {
				if (i[t] === void 0) continue;
				let { correct: n, applyTo: o, isCSSVariable: s } = To[t], c = a === "none" ? i[t] : n(i[t], r);
				if (o) {
					let t = o.length;
					for (let n = 0; n < t; n++) e[o[n]] = c;
				} else s ? this.options.visualElement.renderState.vars[t] = c : e[t] = c;
			}
			this.options.layoutId && (e.pointerEvents = r === this ? zs(t?.pointerEvents) || "" : "none");
		}
		clearSnapshot() {
			this.resumeFrom = this.snapshot = void 0;
		}
		resetTree() {
			this.root.nodes.forEach((e) => e.currentAnimation?.stop()), this.root.nodes.forEach(ec), this.root.sharedNodes.clear();
		}
	};
}
function Ys(e) {
	e.updateLayout();
}
function Xs(e) {
	let t = e.resumeFrom?.snapshot || e.snapshot;
	if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
		let { layoutBox: n, measuredBox: r } = e.layout, { animationType: i } = e.options, a = t.source !== e.layout.source;
		if (i === "size") $((e) => {
			let r = a ? t.measuredBox[e] : t.layoutBox[e], i = Q(r);
			r.min = n[e].min, r.max = r.min + i;
		});
		else if (i === "x" || i === "y") {
			let e = i === "x" ? "y" : "x";
			Qo(a ? t.measuredBox[e] : t.layoutBox[e], n[e]);
		} else yc(i, t.layoutBox, n) && $((r) => {
			let i = a ? t.measuredBox[r] : t.layoutBox[r], o = Q(n[r]);
			i.max = i.min + o, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[r].max = e.relativeTarget[r].min + o);
		});
		let o = Aa();
		os(o, n, t.layoutBox);
		let s = Aa();
		a ? os(s, e.applyTransform(r, !0), t.measuredBox) : os(s, n, t.layoutBox);
		let c = !vs(o), l = !1;
		if (!e.resumeFrom) {
			let r = e.getClosestProjectingParent();
			if (r && !r.resumeFrom) {
				let { snapshot: i, layout: a } = r;
				if (i && a) {
					let o = e.options.layoutAnchor || void 0, s = J();
					us(s, t.layoutBox, i.layoutBox, o);
					let c = J();
					us(c, n, a.layoutBox, o), Ss(s, c) || (l = !0), r.options.layoutRoot && (e.relativeTarget = c, e.relativeTargetOrigin = s, e.relativeParent = r);
				}
			}
		}
		e.notifyListeners("didUpdate", {
			layout: n,
			snapshot: t,
			delta: s,
			layoutDelta: o,
			hasLayoutChanged: c,
			hasRelativeLayoutChanged: l
		});
	} else if (e.isLead()) {
		let { onExitComplete: t } = e.options;
		t && t();
	}
	e.options.transition = void 0;
}
function Zs(e) {
	Ta.value && Hs.nodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty ||= !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty), e.isTransformDirty ||= e.parent.isTransformDirty);
}
function Qs(e) {
	e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function $s(e) {
	e.clearSnapshot();
}
function ec(e) {
	e.clearMeasurements();
}
function tc(e) {
	e.isLayoutDirty = !0, e.updateLayout();
}
function nc(e) {
	e.isLayoutDirty = !1;
}
function rc(e) {
	e.isAnimationBlocked && e.layout && !e.isLayoutDirty && (e.snapshot = e.layout, e.isLayoutDirty = !0);
}
function ic(e) {
	let { visualElement: t } = e.options;
	t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function ac(e) {
	e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function oc(e) {
	e.resolveTargetDelta();
}
function sc(e) {
	e.calcProjection();
}
function cc(e) {
	e.resetSkewAndRotation();
}
function lc(e) {
	e.removeLeadSnapshot();
}
function uc(e, t, n) {
	e.translate = H(t.translate, 0, n), e.scale = H(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function dc(e, t, n, r) {
	e.min = H(t.min, n.min, r), e.max = H(t.max, n.max, r);
}
function fc(e, t, n, r) {
	dc(e.x, t.x, n.x, r), dc(e.y, t.y, n.y, r);
}
function pc(e) {
	return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var mc = {
	duration: .45,
	ease: [
		.4,
		0,
		.1,
		1
	]
}, hc = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), gc = hc("applewebkit/") && !hc("chrome/") ? Math.round : A;
function _c(e) {
	e.min = gc(e.min), e.max = gc(e.max);
}
function vc(e) {
	_c(e.x), _c(e.y);
}
function yc(e, t, n) {
	return e === "position" || e === "preserve-aspect" && !is(Cs(t), Cs(n), .2);
}
function bc(e) {
	return e !== e.root && e.scroll?.wasRoot;
}
//#endregion
//#region ../../node_modules/.pnpm/motion-dom@12.43.0/node_modules/motion-dom/dist/es/projection/node/DocumentProjectionNode.mjs
var xc = Js({
	attachResizeListener: (e, t) => Fs(e, "resize", t),
	measureScroll: () => ({
		x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
		y: document.documentElement.scrollTop || document.body?.scrollTop || 0
	}),
	checkIsScrollRoot: () => !0
}), Sc = { current: void 0 }, Cc = Js({
	measureScroll: (e) => ({
		x: e.scrollLeft,
		y: e.scrollTop
	}),
	defaultParent: () => {
		if (!Sc.current) {
			let e = new xc({});
			e.mount(window), e.setOptions({ layoutScroll: !0 }), Sc.current = e;
		}
		return Sc.current;
	},
	resetTransform: (e, t) => {
		e.style.transform = t === void 0 ? "none" : t;
	},
	checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), wc = i({
	transformPagePoint: (e) => e,
	isStatic: !1,
	reducedMotion: "never"
});
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/utils/use-composed-ref.mjs
function Tc(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
function Ec(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = Tc(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : Tc(e[t], null);
			}
		};
	};
}
function Dc(...t) {
	return e.useCallback(Ec(...t), t);
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/components/AnimatePresence/PopChild.mjs
var Oc = class extends e.Component {
	getSnapshotBeforeUpdate(e) {
		let t = this.props.childRef.current;
		if (Ui(t) && e.isPresent && !this.props.isPresent && this.props.pop !== !1) {
			let e = t.offsetParent, n = Ui(e) && e.offsetWidth || 0, r = Ui(e) && e.offsetHeight || 0, i = getComputedStyle(t), a = this.props.sizeRef.current;
			a.height = parseFloat(i.height), a.width = parseFloat(i.width), a.top = t.offsetTop, a.left = t.offsetLeft, a.right = n - a.width - a.left, a.bottom = r - a.height - a.top, a.direction = i.direction;
		}
		return null;
	}
	componentDidUpdate() {}
	render() {
		return this.props.children;
	}
};
function kc({ children: t, isPresent: n, anchorX: r, anchorY: i, root: a, pop: o }) {
	let s = d(), c = h(null), u = h({
		width: 0,
		height: 0,
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		direction: "ltr"
	}), { nonce: p } = l(wc), m = Dc(c, t.props?.ref ?? t?.ref);
	return f(() => {
		let { width: e, height: t, top: l, left: d, right: f, bottom: m, direction: h } = u.current;
		if (n || o === !1 || !c.current || !e || !t) return;
		let g = h === "rtl", _ = r === "left" ? g ? `right: ${f}` : `left: ${d}` : g ? `left: ${d}` : `right: ${f}`, v = i === "bottom" ? `bottom: ${m}` : `top: ${l}`;
		c.current.dataset.motionPopId = s;
		let y = document.createElement("style");
		p && (y.nonce = p);
		let b = a ?? document.head;
		return b.appendChild(y), y.sheet && y.sheet.insertRule(`
          [data-motion-pop-id="${s}"] {
            position: absolute !important;
            width: ${e}px !important;
            height: ${t}px !important;
            ${_}px !important;
            ${v}px !important;
          }
        `), () => {
			c.current?.removeAttribute("data-motion-pop-id"), b.contains(y) && b.removeChild(y);
		};
	}, [n]), v(Oc, {
		isPresent: n,
		childRef: c,
		sizeRef: u,
		pop: o,
		children: o === !1 ? t : e.cloneElement(t, { ref: m })
	});
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.mjs
var Ac = ({ children: t, initial: n, isPresent: r, onExitComplete: i, custom: a, presenceAffectsLayout: o, mode: s, anchorX: c, anchorY: l, root: u }) => {
	let f = ne(jc), p = d(), h = !0, g = m(() => (h = !1, {
		id: p,
		initial: n,
		isPresent: r,
		custom: a,
		onExitComplete: (e) => {
			f.set(e, !0);
			for (let e of f.values()) if (!e) return;
			i && i();
		},
		register: (e) => (f.set(e, !1), () => f.delete(e))
	}), [
		r,
		f,
		i
	]);
	return o && h && (g = { ...g }), m(() => {
		f.forEach((e, t) => f.set(t, !1));
	}, [r]), e.useEffect(() => {
		!r && !f.size && i && i();
	}, [r]), t = v(kc, {
		pop: s === "popLayout",
		isPresent: r,
		anchorX: c,
		anchorY: l,
		root: u,
		children: t
	}), v(ie.Provider, {
		value: g,
		children: t
	});
};
function jc() {
	return /* @__PURE__ */ new Map();
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs
function Mc(e = !0) {
	let t = l(ie);
	if (t === null) return [!0, null];
	let { isPresent: n, onExitComplete: r, register: i } = t, a = d();
	u(() => {
		if (e) return i(a);
	}, [e]);
	let o = c(() => e && r && r(a), [
		a,
		r,
		e
	]);
	return !n && r ? [!1, o] : [!0];
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/components/AnimatePresence/utils.mjs
var Nc = (e) => e.key || "";
function Pc(e) {
	let n = [];
	return t.forEach(e, (e) => {
		s(e) && n.push(e);
	}), n;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs
var Fc = ({ children: e, custom: t, initial: n = !0, onExitComplete: r, presenceAffectsLayout: i = !0, mode: a = "sync", propagate: o = !1, anchorX: s = "left", anchorY: c = "top", root: u }) => {
	let [d, f] = Mc(o), p = m(() => Pc(e), [e]), y = o && !d ? [] : p.map(Nc), b = h(!0), x = h(p), S = ne(() => /* @__PURE__ */ new Map()), C = h(/* @__PURE__ */ new Set()), [w, T] = g(p), [E, ee] = g(p);
	re(() => {
		b.current = !1, x.current = p;
		for (let e = 0; e < E.length; e++) {
			let t = Nc(E[e]);
			y.includes(t) ? (S.delete(t), C.current.delete(t)) : S.get(t) !== !0 && S.set(t, !1);
		}
	}, [
		E,
		y.length,
		y.join("-")
	]);
	let ie = [];
	if (p !== w) {
		let e = [...p];
		for (let t = 0; t < E.length; t++) {
			let n = E[t], r = Nc(n);
			y.includes(r) || (e.splice(t, 0, n), ie.push(n));
		}
		return a === "wait" && ie.length && (e = ie), ee(Pc(e)), T(p), null;
	}
	process.env.NODE_ENV !== "production" && a === "wait" && E.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its mode is set to \"wait\". This will lead to odd visual behaviour.");
	let { forceRender: ae } = l(te);
	return v(_, { children: E.map((e) => {
		let l = Nc(e), m = o && !d ? !1 : p === E || y.includes(l);
		return v(Ac, {
			isPresent: m,
			initial: !b.current || n ? void 0 : !1,
			custom: t,
			presenceAffectsLayout: i,
			mode: a,
			root: u,
			onExitComplete: m ? void 0 : () => {
				if (C.current.has(l)) return;
				if (S.has(l)) C.current.add(l), S.set(l, !0);
				else return;
				let e = !0;
				S.forEach((t) => {
					t || (e = !1);
				}), e && (ae?.(), ee(x.current), o && f?.(), r && r());
			},
			anchorX: s,
			anchorY: c,
			children: e
		}, l);
	}) });
}, Ic = i({ strict: !1 }), Lc = {
	animation: [
		"animate",
		"variants",
		"whileHover",
		"whileTap",
		"exit",
		"whileInView",
		"whileFocus",
		"whileDrag"
	],
	exit: ["exit"],
	drag: ["drag", "dragControls"],
	focus: ["whileFocus"],
	hover: [
		"whileHover",
		"onHoverStart",
		"onHoverEnd"
	],
	tap: [
		"whileTap",
		"onTap",
		"onTapStart",
		"onTapCancel"
	],
	pan: [
		"onPan",
		"onPanStart",
		"onPanSessionStart",
		"onPanEnd"
	],
	inView: [
		"whileInView",
		"onViewportEnter",
		"onViewportLeave"
	],
	layout: ["layout", "layoutId"]
}, Rc = !1;
function zc() {
	if (Rc) return;
	let e = {};
	for (let t in Lc) e[t] = { isEnabled: (e) => Lc[t].some((t) => !!e[t]) };
	Ka(e), Rc = !0;
}
function Bc() {
	return zc(), qa();
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/features/load-features.mjs
function Vc(e) {
	let t = Bc();
	for (let n in e) t[n] = {
		...t[n],
		...e[n]
	};
	Ka(t);
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/utils/valid-prop.mjs
var Hc = /* @__PURE__ */ new Set(/* @__PURE__ */ "animate.exit.variants.initial.style.values.variants.transition.transformTemplate.custom.inherit.onBeforeLayoutMeasure.onAnimationStart.onAnimationComplete.onUpdate.onDragStart.onDrag.onDragEnd.onMeasureDragConstraints.onDirectionLock.onDragTransitionEnd._dragX._dragY.onHoverStart.onHoverEnd.onViewportEnter.onViewportLeave.globalTapTarget.propagate.ignoreStrict.viewport".split("."));
function Uc(e) {
	return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || Hc.has(e);
}
//#endregion
//#region __vite-optional-peer-dep:@emotion/is-prop-valid:framer-motion
var Wc = /* @__PURE__ */ T({ default: () => Gc }), Gc, Kc = w((() => {
	throw Gc = {}, Error("Could not resolve \"@emotion/is-prop-valid\" imported by \"framer-motion\". Is it installed?");
})), qc = (e) => !Uc(e);
function Jc(e) {
	typeof e == "function" && (qc = (t) => t.startsWith("on") ? !Uc(t) : e(t));
}
try {
	Jc((Kc(), ee(Wc)).default);
} catch {}
function Yc(e, t, n) {
	let r = {};
	for (let i in e) i === "values" && typeof e.values == "object" || K(e[i]) || (qc(i) || n === !0 && Uc(i) || !t && !Uc(i) || e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
	return r;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/context/MotionContext/index.mjs
var Xc = /* @__PURE__ */ i({});
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/context/MotionContext/utils.mjs
function Zc(e, t) {
	if (La(e)) {
		let { initial: t, animate: n } = e;
		return {
			initial: t === !1 || Pa(t) ? t : void 0,
			animate: Pa(n) ? n : void 0
		};
	}
	return e.inherit === !1 ? {} : t;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/context/MotionContext/create.mjs
function Qc(e) {
	let { initial: t, animate: n } = Zc(e, l(Xc));
	return m(() => ({
		initial: t,
		animate: n
	}), [$c(t), $c(n)]);
}
function $c(e) {
	return Array.isArray(e) ? e.join(" ") : e;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/html/utils/create-render-state.mjs
var el = () => ({
	style: {},
	transform: {},
	transformOrigin: {},
	vars: {}
});
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/html/use-props.mjs
function tl(e, t, n) {
	for (let r in t) !K(t[r]) && !Eo(r, n) && (e[r] = t[r]);
}
function nl({ transformTemplate: e }, t) {
	return m(() => {
		let n = el();
		return bo(n, t, e), Object.assign({}, n.vars, n.style);
	}, [t]);
}
function rl(e, t) {
	let n = e.style || {}, r = {};
	return tl(r, n, e), Object.assign(r, nl(e, t)), r;
}
function il(e, t) {
	let n = {}, r = rl(e, t);
	return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/svg/utils/create-render-state.mjs
var al = () => ({
	...el(),
	attrs: {}
});
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/svg/use-props.mjs
function ol(e, t, n, r) {
	let i = m(() => {
		let n = al();
		return Io(n, t, Ro(r), e.transformTemplate, e.style), {
			...n.attrs,
			style: { ...n.style }
		};
	}, [t]);
	if (e.style) {
		let t = {};
		tl(t, e.style, e), i.style = {
			...t,
			...i.style
		};
	}
	return i;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/svg/lowercase-elements.mjs
var sl = [
	"animate",
	"circle",
	"defs",
	"desc",
	"ellipse",
	"g",
	"image",
	"line",
	"filter",
	"marker",
	"mask",
	"metadata",
	"path",
	"pattern",
	"polygon",
	"polyline",
	"rect",
	"stop",
	"switch",
	"symbol",
	"svg",
	"text",
	"tspan",
	"use",
	"view"
];
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/dom/utils/is-svg-component.mjs
function cl(e) {
	return typeof e != "string" || e.includes("-") ? !1 : !!(sl.indexOf(e) > -1 || /[A-Z]/u.test(e));
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/dom/use-render.mjs
function ll(e, t, n, { latestValues: i }, o, s = !1, c) {
	let l = (c ?? cl(e) ? ol : il)(t, i, o, e), u = Yc(t, typeof e == "string", s), d = e === r ? {} : {
		...u,
		...l,
		ref: n
	}, { children: f } = t, p = m(() => K(f) ? f.get() : f, [f]);
	return a(e, {
		...d,
		children: p
	});
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/utils/use-visual-state.mjs
function ul({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
	return {
		latestValues: dl(n, r, i, e),
		renderState: t()
	};
}
function dl(e, t, n, r) {
	let i = {}, a = r(e, {});
	for (let e in a) i[e] = zs(a[e]);
	let { initial: o, animate: s } = e, c = La(e), l = Ra(e);
	t && l && !c && e.inherit !== !1 && (o === void 0 && (o = t.initial), s === void 0 && (s = t.animate));
	let u = n ? n.initial === !1 : !1;
	u ||= o === !1;
	let d = u ? s : o;
	if (d && typeof d != "boolean" && !Na(d)) {
		let t = Array.isArray(d) ? d : [d];
		for (let n = 0; n < t.length; n++) {
			let r = ii(e, t[n]);
			if (r) {
				let { transitionEnd: e, transition: t, ...n } = r;
				for (let e in n) {
					let t = n[e];
					if (Array.isArray(t)) {
						let e = u ? t.length - 1 : 0;
						t = t[e];
					}
					t !== null && (i[e] = t);
				}
				for (let t in e) i[t] = e[t];
			}
		}
	}
	return i;
}
var fl = (e) => (t, n) => {
	let r = l(Xc), i = l(ie), a = () => ul(e, t, r, i);
	return n ? a() : ne(a);
}, pl = /*@__PURE__*/ fl({
	scrapeMotionValuesFromProps: Do,
	createRenderState: el
}), ml = /*@__PURE__*/ fl({
	scrapeMotionValuesFromProps: Bo,
	createRenderState: al
}), hl = Symbol.for("motionComponentSymbol");
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/utils/use-motion-ref.mjs
function gl(e, t, n) {
	let r = h(n);
	f(() => {
		r.current = n;
	});
	let i = h(null);
	return c((n) => {
		n && e.onMount?.(n), t && (n ? t.mount(n) : t.unmount());
		let a = r.current;
		if (typeof a == "function") if (n) {
			let e = a(n);
			typeof e == "function" && (i.current = e);
		} else i.current ? (i.current(), i.current = null) : a(n);
		else a && (a.current = n);
	}, [t]);
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/context/SwitchLayoutGroupContext.mjs
var _l = i({});
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/utils/is-ref-object.mjs
function vl(e) {
	return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/utils/use-visual-element.mjs
function yl(e, t, n, r, i, a) {
	let { visualElement: o } = l(Xc), s = l(Ic), c = l(ie), d = l(wc), p = d.reducedMotion, m = d.skipAnimations, g = h(null), _ = h(!1);
	r ||= s.renderer, !g.current && r && (g.current = r(e, {
		visualState: t,
		parent: o,
		props: n,
		presenceContext: c,
		blockInitialAnimation: c ? c.initial === !1 : !1,
		reducedMotionConfig: p,
		skipAnimations: m,
		isSVG: a
	}), _.current && g.current && (g.current.manuallyAnimateOnMount = !0));
	let v = g.current, y = l(_l);
	v && !v.projection && i && (v.type === "html" || v.type === "svg") && bl(g.current, n, i, y);
	let b = h(!1);
	f(() => {
		v && b.current && v.update(n, c);
	});
	let x = n[mi], S = h(!!x && typeof window < "u" && !window.MotionHandoffIsComplete?.(x) && window.MotionHasOptimisedAnimation?.(x));
	return re(() => {
		_.current = !0, v && (b.current = !0, window.MotionIsMounted = !0, v.updateFeatures(), v.scheduleRenderMicrotask(), S.current && v.animationState && v.animationState.animateChanges());
	}), u(() => {
		v && (!S.current && v.animationState && v.animationState.animateChanges(), S.current &&= (queueMicrotask(() => {
			window.MotionHandoffMarkAsComplete?.(x);
		}), !1), v.enteringChildren = void 0);
	}), v;
}
function bl(e, t, n, r) {
	let { layoutId: i, layout: a, drag: o, dragConstraints: s, layoutScroll: c, layoutRoot: l, layoutAnchor: u, layoutCrossfade: d } = t;
	e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : xl(e.parent)), e.projection.setOptions({
		layoutId: i,
		layout: a,
		alwaysMeasureLayout: !!o || s && vl(s),
		visualElement: e,
		animationType: typeof a == "string" ? a : "both",
		initialPromotionConfig: r,
		crossfade: d,
		layoutScroll: c,
		layoutRoot: l,
		layoutAnchor: u
	});
}
function xl(e) {
	if (e) return e.options.allowProjection === !1 ? xl(e.parent) : e.projection;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/index.mjs
function Sl(e, { forwardMotionProps: t = !1, type: n } = {}, r, i) {
	r && Vc(r);
	let a = n ? n === "svg" : cl(e), s = a ? ml : pl;
	function c(n, o) {
		let c, u = {
			...l(wc),
			...n,
			layoutId: Cl(n)
		}, { isStatic: d } = u, f = Qc(n), p = s(n, d);
		if (!d && typeof window < "u") {
			wl(u, r);
			let t = Tl(u);
			c = t.MeasureLayout, f.visualElement = yl(e, p, u, i, t.ProjectionNode, a);
		}
		return y(Xc.Provider, {
			value: f,
			children: [c && f.visualElement ? v(c, {
				visualElement: f.visualElement,
				...u
			}) : null, ll(e, n, gl(p, f.visualElement, o), p, d, t, a)]
		});
	}
	c.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
	let u = o(c);
	return u[hl] = e, u;
}
function Cl({ layoutId: e }) {
	let t = l(te).id;
	return t && e !== void 0 ? t + "-" + e : e;
}
function wl(e, t) {
	let n = l(Ic).strict;
	if (process.env.NODE_ENV !== "production" && t && n) {
		let t = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
		e.ignoreStrict ? ce(!1, t, "lazy-strict-mode") : O(!1, t, "lazy-strict-mode");
	}
}
function Tl(e) {
	let { drag: t, layout: n } = Bc();
	if (!t && !n) return {};
	let r = {
		...t,
		...n
	};
	return {
		MeasureLayout: t?.isEnabled(e) || n?.isEnabled(e) ? r.MeasureLayout : void 0,
		ProjectionNode: r.ProjectionNode
	};
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/components/create-proxy.mjs
function El(e, t) {
	if (typeof Proxy > "u") return Sl;
	let n = /* @__PURE__ */ new Map(), r = (n, r) => Sl(n, r, e, t);
	return new Proxy((e, t) => (process.env.NODE_ENV !== "production" && ve(!1, "motion() is deprecated. Use motion.create() instead."), r(e, t)), { get: (i, a) => a === "create" ? r : (n.has(a) || n.set(a, Sl(a, void 0, e, t)), n.get(a)) });
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/render/dom/create-visual-element.mjs
var Dl = (e, t) => t.isSVG ?? cl(e) ? new Vo(t) : new ko(t, { allowProjection: e !== r }), Ol = class extends Y {
	constructor(e) {
		super(e), e.animationState ||= Jo(e);
	}
	updateAnimationControlsSubscription() {
		let { animate: e } = this.node.getProps();
		Na(e) && (this.unmountControls = e.subscribe(this.node));
	}
	mount() {
		this.updateAnimationControlsSubscription();
	}
	update() {
		let { animate: e } = this.node.getProps(), { animate: t } = this.node.prevProps || {};
		e !== t && this.updateAnimationControlsSubscription();
	}
	unmount() {
		this.node.animationState.reset(), this.unmountControls?.();
	}
}, kl = 0, Al = {
	animation: { Feature: Ol },
	exit: { Feature: class extends Y {
		constructor() {
			super(...arguments), this.id = kl++, this.isExitComplete = !1;
		}
		update() {
			if (!this.node.presenceContext) return;
			let { isPresent: e, onExitComplete: t } = this.node.presenceContext, { isPresent: n } = this.node.prevPresenceContext || {};
			if (!this.node.animationState || e === n) return;
			if (e && n === !1) {
				if (this.isExitComplete) {
					let { initial: e, custom: t } = this.node.getProps();
					if (typeof e == "string" || typeof e == "object" && e && !Array.isArray(e)) {
						let n = ai(this.node, e, t);
						if (n) {
							let { transition: e, transitionEnd: t, ...r } = n;
							for (let e in r) this.node.getValue(e)?.jump(r[e]);
						}
					}
					this.node.animationState.reset(), this.node.animationState.animateChanges();
				} else this.node.animationState.setActive("exit", !1);
				this.isExitComplete = !1;
				return;
			}
			let r = this.node.animationState.setActive("exit", !e);
			t && !e && r.then(() => {
				this.isExitComplete = !0, t(this.id);
			});
		}
		mount() {
			let { register: e, onExitComplete: t } = this.node.presenceContext || {};
			t && t(this.id), e && (this.unmount = e(this.id));
		}
		unmount() {}
	} }
};
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/events/event-info.mjs
function jl(e) {
	return { point: {
		x: e.pageX,
		y: e.pageY
	} };
}
var Ml = (e) => (t) => Qi(t) && e(t, jl(t));
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/events/add-pointer-event.mjs
function Nl(e, t, n, r) {
	return Fs(e, t, Ml(n), r);
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/utils/get-context-window.mjs
var Pl = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Fl = (e, t) => Math.abs(e - t);
function Il(e, t) {
	let n = Fl(e.x, t.x), r = Fl(e.y, t.y);
	return Math.sqrt(n ** 2 + r ** 2);
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/gestures/pan/PanSession.mjs
var Ll = /*#__PURE__*/ new Set(["auto", "scroll"]), Rl = class {
	constructor(e, t, { transformPagePoint: n, contextWindow: r = window, dragSnapToOrigin: i = !1, distanceThreshold: a = 3, element: o } = {}) {
		if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (e) => {
			this.handleScroll(e.target);
		}, this.onWindowScroll = () => {
			this.handleScroll(window);
		}, this.updatePoint = () => {
			if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
			this.lastRawMoveEventInfo && (this.lastMoveEventInfo = zl(this.lastRawMoveEventInfo, this.transformPagePoint));
			let e = Vl(this.lastMoveEventInfo, this.history), t = this.startEvent !== null, n = Il(e.offset, {
				x: 0,
				y: 0
			}) >= this.distanceThreshold;
			if (!t && !n) return;
			let { point: r } = e, { timestamp: i } = F;
			this.history.push({
				...r,
				timestamp: i
			});
			let { onStart: a, onMove: o } = this.handlers;
			t || (a && a(this.lastMoveEvent, e), this.startEvent = this.lastMoveEvent), o && o(this.lastMoveEvent, e);
		}, this.handlePointerMove = (e, t) => {
			this.lastMoveEvent = e, this.lastRawMoveEventInfo = t, this.lastMoveEventInfo = zl(t, this.transformPagePoint), N.update(this.updatePoint, !0);
		}, this.handlePointerUp = (e, t) => {
			this.end();
			let { onEnd: n, onSessionEnd: r, resumeAnimation: i } = this.handlers;
			if ((this.dragSnapToOrigin || !this.startEvent) && i && i(), !(this.lastMoveEvent && this.lastMoveEventInfo)) return;
			let a = Vl(e.type === "pointercancel" ? this.lastMoveEventInfo : zl(t, this.transformPagePoint), this.history);
			this.startEvent && n && n(e, a), r && r(e, a);
		}, !Qi(e)) return;
		this.dragSnapToOrigin = i, this.handlers = t, this.transformPagePoint = n, this.distanceThreshold = a, this.contextWindow = r || window;
		let s = zl(jl(e), this.transformPagePoint), { point: c } = s, { timestamp: l } = F;
		this.history = [{
			...c,
			timestamp: l
		}];
		let { onSessionStart: u } = t;
		u && u(e, Vl(s, this.history)), this.removeListeners = pe(Nl(this.contextWindow, "pointermove", this.handlePointerMove), Nl(this.contextWindow, "pointerup", this.handlePointerUp), Nl(this.contextWindow, "pointercancel", this.handlePointerUp)), o && this.startScrollTracking(o);
	}
	startScrollTracking(e) {
		let t = e.parentElement;
		for (; t;) {
			let e = getComputedStyle(t);
			(Ll.has(e.overflowX) || Ll.has(e.overflowY)) && this.scrollPositions.set(t, {
				x: t.scrollLeft,
				y: t.scrollTop
			}), t = t.parentElement;
		}
		this.scrollPositions.set(window, {
			x: window.scrollX,
			y: window.scrollY
		}), window.addEventListener("scroll", this.onElementScroll, { capture: !0 }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
			window.removeEventListener("scroll", this.onElementScroll, { capture: !0 }), window.removeEventListener("scroll", this.onWindowScroll);
		};
	}
	handleScroll(e) {
		let t = this.scrollPositions.get(e);
		if (!t) return;
		let n = e === window, r = n ? {
			x: window.scrollX,
			y: window.scrollY
		} : {
			x: e.scrollLeft,
			y: e.scrollTop
		}, i = {
			x: r.x - t.x,
			y: r.y - t.y
		};
		i.x === 0 && i.y === 0 || (n ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += i.x, this.lastMoveEventInfo.point.y += i.y) : this.history.length > 0 && (this.history[0].x -= i.x, this.history[0].y -= i.y), this.scrollPositions.set(e, r), N.update(this.updatePoint, !0));
	}
	updateHandlers(e) {
		this.handlers = e;
	}
	end() {
		this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), P(this.updatePoint);
	}
};
function zl(e, t) {
	return t ? { point: t(e.point) } : e;
}
function Bl(e, t) {
	return {
		x: e.x - t.x,
		y: e.y - t.y
	};
}
function Vl({ point: e }, t) {
	return {
		point: e,
		delta: Bl(e, Ul(t)),
		offset: Bl(e, Hl(t)),
		velocity: Wl(t, .1)
	};
}
function Hl(e) {
	return e[0];
}
function Ul(e) {
	return e[e.length - 1];
}
function Wl(e, t) {
	if (e.length < 2) return {
		x: 0,
		y: 0
	};
	let n = e.length - 1, r = null, i = Ul(e);
	for (; n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > /* @__PURE__ */ j(t)));) n--;
	if (!r) return {
		x: 0,
		y: 0
	};
	r === e[0] && e.length > 2 && i.timestamp - r.timestamp > /* @__PURE__ */ j(t) * 2 && (r = e[1]);
	let a = /* @__PURE__ */ M(i.timestamp - r.timestamp);
	if (a === 0) return {
		x: 0,
		y: 0
	};
	let o = {
		x: (i.x - r.x) / a,
		y: (i.y - r.y) / a
	};
	return o.x === Infinity && (o.x = 0), o.y === Infinity && (o.y = 0), o;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/gestures/drag/utils/constraints.mjs
function Gl(e, { min: t, max: n }, r) {
	return t !== void 0 && e < t ? e = r ? H(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? H(n, e, r.max) : Math.min(e, n)), e;
}
function Kl(e, t, n) {
	return {
		min: t === void 0 ? void 0 : e.min + t,
		max: n === void 0 ? void 0 : e.max + n - (e.max - e.min)
	};
}
function ql(e, { top: t, left: n, bottom: r, right: i }) {
	return {
		x: Kl(e.x, n, i),
		y: Kl(e.y, t, r)
	};
}
function Jl(e, t) {
	let n = t.min - e.min, r = t.max - e.max;
	return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), {
		min: n,
		max: r
	};
}
function Yl(e, t) {
	return {
		x: Jl(e.x, t.x),
		y: Jl(e.y, t.y)
	};
}
function Xl(e, t) {
	let n = .5, r = Q(e), i = Q(t);
	return i > r ? n = /* @__PURE__ */ me(t.min, t.max - r, e.min) : r > i && (n = /* @__PURE__ */ me(e.min, e.max - i, t.min)), D(0, 1, n);
}
function Zl(e, t) {
	let n = {};
	return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
var Ql = .35;
function $l(e = Ql) {
	return e === !1 ? e = 0 : e === !0 && (e = Ql), {
		x: eu(e, "left", "right"),
		y: eu(e, "top", "bottom")
	};
}
function eu(e, t, n) {
	return {
		min: tu(e, t),
		max: tu(e, n)
	};
}
function tu(e, t) {
	return typeof e == "number" ? e : e[t] || 0;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/gestures/drag/VisualElementDragControls.mjs
var nu = /* @__PURE__ */ new WeakMap(), ru = class {
	constructor(e) {
		this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = {
			x: 0,
			y: 0
		}, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = J(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
	}
	start(e, { snapToCursor: t = !1, distanceThreshold: n } = {}) {
		let { presenceContext: r } = this.visualElement;
		if (r && r.isPresent === !1) return;
		let i = (e) => {
			t && this.snapToCursor(jl(e).point), this.stopAnimation();
		}, a = (e, t) => {
			let { drag: n, dragPropagation: r, onDragStart: i } = this.getProps();
			if (n && !r && (this.openDragLock && this.openDragLock(), this.openDragLock = qi(n), !this.openDragLock)) return;
			this.latestPointerEvent = e, this.latestPanInfo = t, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), $((e) => {
				let t = this.getAxisMotionValue(e).get() || 0;
				if (R.test(t)) {
					let { projection: n } = this.visualElement;
					if (n && n.layout) {
						let r = n.layout.layoutBox[e];
						r && (t = Q(r) * (parseFloat(t) / 100));
					}
				}
				this.originPoint[e] = t;
			}), i && N.update(() => i(e, t), !1, !0), fi(this.visualElement, "transform");
			let { animationState: a } = this.visualElement;
			a && a.setActive("whileDrag", !0);
		}, o = (e, t) => {
			this.latestPointerEvent = e, this.latestPanInfo = t;
			let { dragPropagation: n, dragDirectionLock: r, onDirectionLock: i, onDrag: a } = this.getProps();
			if (!n && !this.openDragLock) return;
			let { offset: o } = t;
			if (r && this.currentDirection === null) {
				this.currentDirection = su(o), this.currentDirection !== null && i && i(this.currentDirection);
				return;
			}
			this.updateAxis("x", t.point, o), this.updateAxis("y", t.point, o), this.visualElement.render(), a && N.update(() => a(e, t), !1, !0);
		}, s = (e, t) => {
			this.latestPointerEvent = e, this.latestPanInfo = t, this.stop(e, t), this.latestPointerEvent = null, this.latestPanInfo = null;
		}, c = () => {
			let { dragSnapToOrigin: e } = this.getProps();
			(e || this.constraints) && this.startAnimation({
				x: 0,
				y: 0
			});
		}, { dragSnapToOrigin: l } = this.getProps();
		this.panSession = new Rl(e, {
			onSessionStart: i,
			onStart: a,
			onMove: o,
			onSessionEnd: s,
			resumeAnimation: c
		}, {
			transformPagePoint: this.visualElement.getTransformPagePoint(),
			dragSnapToOrigin: l,
			distanceThreshold: n,
			contextWindow: Pl(this.visualElement),
			element: this.visualElement.current
		});
	}
	stop(e, t) {
		let n = e || this.latestPointerEvent, r = t || this.latestPanInfo, i = this.isDragging;
		if (this.cancel(), !i || !r || !n) return;
		let { velocity: a } = r;
		this.startAnimation(a);
		let { onDragEnd: o } = this.getProps();
		o && N.postRender(() => o(n, r));
	}
	cancel() {
		this.isDragging = !1;
		let { projection: e, animationState: t } = this.visualElement;
		e && (e.isAnimationBlocked = !1), this.endPanSession();
		let { dragPropagation: n } = this.getProps();
		!n && this.openDragLock && (this.openDragLock(), this.openDragLock = null), t && t.setActive("whileDrag", !1);
	}
	endPanSession() {
		this.panSession && this.panSession.end(), this.panSession = void 0;
	}
	updateAxis(e, t, n) {
		let { drag: r } = this.getProps();
		if (!n || !ou(e, r, this.currentDirection)) return;
		let i = this.getAxisMotionValue(e), a = this.originPoint[e] + n[e];
		this.constraints && this.constraints[e] && (a = Gl(a, this.constraints[e], this.elastic[e])), i.set(a);
	}
	resolveConstraints() {
		let { dragConstraints: e, dragElastic: t } = this.getProps(), n = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, r = this.constraints;
		e && vl(e) ? this.constraints ||= this.resolveRefConstraints() : e && n ? this.constraints = ql(n.layoutBox, e) : this.constraints = !1, this.elastic = $l(t), r !== this.constraints && !vl(e) && n && this.constraints && !this.hasMutatedConstraints && $((e) => {
			this.constraints !== !1 && this.getAxisMotionValue(e) && (this.constraints[e] = Zl(n.layoutBox[e], this.constraints[e]));
		});
	}
	resolveRefConstraints() {
		let { dragConstraints: e, onMeasureDragConstraints: t } = this.getProps();
		if (!e || !vl(e)) return !1;
		let n = e.current;
		O(n !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
		let { projection: r } = this.visualElement;
		if (!r || !r.layout) return !1;
		r.root && (r.root.scroll = void 0, r.root.updateScroll());
		let i = go(n, r.root, this.visualElement.getTransformPagePoint()), a = Yl(r.layout.layoutBox, i);
		if (t) {
			let e = t(Za(a));
			this.hasMutatedConstraints = !!e, e && (a = Xa(e));
		}
		return a;
	}
	startAnimation(e) {
		let { drag: t, dragMomentum: n, dragElastic: r, dragTransition: i, dragSnapToOrigin: a, onDragTransitionEnd: o } = this.getProps(), s = this.constraints || {}, c = $((o) => {
			if (!ou(o, t, this.currentDirection)) return;
			let c = s && s[o] || {};
			(a === !0 || a === o) && (c = {
				min: 0,
				max: 0
			});
			let l = r ? 200 : 1e6, u = r ? 40 : 1e7, d = {
				type: "inertia",
				velocity: n ? e[o] : 0,
				bounceStiffness: l,
				bounceDamping: u,
				timeConstant: 750,
				restDelta: 1,
				restSpeed: 10,
				...i,
				...c
			};
			return this.startAxisValueAnimation(o, d);
		});
		return Promise.all(c).then(o);
	}
	startAxisValueAnimation(e, t) {
		let n = this.getAxisMotionValue(e);
		return fi(this.visualElement, e), n.start(Qr(e, n, 0, t, this.visualElement, !1));
	}
	stopAnimation() {
		$((e) => this.getAxisMotionValue(e).stop());
	}
	getAxisMotionValue(e) {
		let t = `_drag${e.toUpperCase()}`;
		return this.visualElement.getProps()[t] || this.visualElement.getValue(e, this.visualElement.latestValues[e] ?? 0);
	}
	snapToCursor(e) {
		$((t) => {
			let { drag: n } = this.getProps();
			if (!ou(t, n, this.currentDirection)) return;
			let { projection: r } = this.visualElement, i = this.getAxisMotionValue(t);
			if (r && r.layout) {
				let { min: n, max: a } = r.layout.layoutBox[t], o = i.get() || 0;
				i.set(e[t] - H(n, a, .5) + o);
			}
		});
	}
	scalePositionWithinConstraints() {
		if (!this.visualElement.current) return;
		let { drag: e, dragConstraints: t } = this.getProps(), { projection: n } = this.visualElement;
		if (!vl(t) || !n || !this.constraints) return;
		this.stopAnimation();
		let r = {
			x: 0,
			y: 0
		};
		$((e) => {
			let t = this.getAxisMotionValue(e);
			if (t && this.constraints !== !1) {
				let n = t.get();
				r[e] = Xl({
					min: n,
					max: n
				}, this.constraints[e]);
			}
		});
		let { transformTemplate: i } = this.visualElement.getProps();
		this.visualElement.current.style.transform = i ? i({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.constraints = !1, this.resolveConstraints(), $((t) => {
			if (!ou(t, e, null)) return;
			let n = this.getAxisMotionValue(t), { min: i, max: a } = this.constraints[t];
			n.set(H(i, a, r[t]));
		}), this.visualElement.render();
	}
	addListeners() {
		if (!this.visualElement.current) return;
		nu.set(this.visualElement, this);
		let e = this.visualElement.current, t = Nl(e, "pointerdown", (t) => {
			let { drag: n, dragListener: r = !0 } = this.getProps(), i = t.target, a = i !== e && na(i);
			n && r && !a && this.start(t);
		}), n, r = () => {
			let { dragConstraints: t } = this.getProps();
			vl(t) && t.current && (this.constraints = this.resolveRefConstraints(), n ||= au(e, t.current, () => this.scalePositionWithinConstraints()));
		}, { projection: i } = this.visualElement, a = i.addEventListener("measure", r);
		i && !i.layout && (i.root && i.root.updateScroll(), i.updateLayout()), N.read(r);
		let o = Fs(window, "resize", () => this.scalePositionWithinConstraints()), s = i.addEventListener("didUpdate", (({ delta: e, hasLayoutChanged: t }) => {
			this.isDragging && t && ($((t) => {
				let n = this.getAxisMotionValue(t);
				n && (this.originPoint[t] += e[t].translate, n.set(n.get() + e[t].translate));
			}), this.visualElement.render());
		}));
		return () => {
			o(), t(), a(), s && s(), n && n();
		};
	}
	getProps() {
		let e = this.visualElement.getProps(), { drag: t = !1, dragDirectionLock: n = !1, dragPropagation: r = !1, dragConstraints: i = !1, dragElastic: a = Ql, dragMomentum: o = !0 } = e;
		return {
			...e,
			drag: t,
			dragDirectionLock: n,
			dragPropagation: r,
			dragConstraints: i,
			dragElastic: a,
			dragMomentum: o
		};
	}
};
function iu(e) {
	let t = !0;
	return () => {
		if (t) {
			t = !1;
			return;
		}
		e();
	};
}
function au(e, t, n) {
	let r = wa(e, iu(n)), i = wa(t, iu(n));
	return () => {
		r(), i();
	};
}
function ou(e, t, n) {
	return (t === !0 || t === e) && (n === null || n === e);
}
function su(e, t = 10) {
	let n = null;
	return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/gestures/drag/index.mjs
var cu = class extends Y {
	constructor(e) {
		super(e), this.removeGroupControls = A, this.removeListeners = A, this.controls = new ru(e);
	}
	mount() {
		let { dragControls: e } = this.node.getProps();
		e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || A;
	}
	update() {
		let { dragControls: e } = this.node.getProps(), { dragControls: t } = this.node.prevProps || {};
		e !== t && (this.removeGroupControls(), e && (this.removeGroupControls = e.subscribe(this.controls)));
	}
	unmount() {
		this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
	}
}, lu = (e) => (t, n) => {
	e && N.update(() => e(t, n), !1, !0);
}, uu = class extends Y {
	constructor() {
		super(...arguments), this.removePointerDownListener = A;
	}
	onPointerDown(e) {
		this.session = new Rl(e, this.createPanHandlers(), {
			transformPagePoint: this.node.getTransformPagePoint(),
			contextWindow: Pl(this.node)
		});
	}
	createPanHandlers() {
		let { onPanSessionStart: e, onPanStart: t, onPan: n, onPanEnd: r } = this.node.getProps();
		return {
			onSessionStart: lu(e),
			onStart: lu(t),
			onMove: lu(n),
			onEnd: (e, t) => {
				delete this.session, r && N.postRender(() => r(e, t));
			}
		};
	}
	mount() {
		this.removePointerDownListener = Nl(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
	}
	update() {
		this.session && this.session.updateHandlers(this.createPanHandlers());
	}
	unmount() {
		this.removePointerDownListener(), this.session && this.session.end();
	}
}, du = !1, fu = class extends n {
	componentDidMount() {
		let { visualElement: e, layoutGroup: t, switchLayoutGroup: n, layoutId: r } = this.props, { projection: i } = e;
		i && (t.group && t.group.add(i), n && n.register && r && n.register(i), du && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
			this.safeToRemove();
		}), i.setOptions({
			...i.options,
			layoutDependency: this.props.layoutDependency,
			onExitComplete: () => this.safeToRemove()
		})), Vs.hasEverUpdated = !0;
	}
	getSnapshotBeforeUpdate(e) {
		let { layoutDependency: t, visualElement: n, drag: r, isPresent: i } = this.props, { projection: a } = n;
		return a ? (a.isPresent = i, e.layoutDependency !== t && a.setOptions({
			...a.options,
			layoutDependency: t
		}), du = !0, r || e.layoutDependency !== t || t === void 0 || e.isPresent !== i ? a.willUpdate() : this.safeToRemove(), e.isPresent !== i && (i ? a.promote() : a.relegate() || N.postRender(() => {
			let e = a.getStack();
			(!e || !e.members.length) && this.safeToRemove();
		})), null) : null;
	}
	componentDidUpdate() {
		let { visualElement: e, layoutAnchor: t } = this.props, { projection: n } = e;
		n && (n.options.layoutAnchor = t, n.root.didUpdate(), Wi.postRender(() => {
			!n.currentAnimation && n.isLead() && this.safeToRemove();
		}));
	}
	componentWillUnmount() {
		let { visualElement: e, layoutGroup: t, switchLayoutGroup: n } = this.props, { projection: r } = e;
		du = !0, r && (r.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(r), n && n.deregister && n.deregister(r));
	}
	safeToRemove() {
		let { safeToRemove: e } = this.props;
		e && e();
	}
	render() {
		return null;
	}
};
function pu(e) {
	let [t, n] = Mc(), r = l(te);
	return v(fu, {
		...e,
		layoutGroup: r,
		switchLayoutGroup: l(_l),
		isPresent: t,
		safeToRemove: n
	});
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/features/drag.mjs
var mu = {
	pan: { Feature: uu },
	drag: {
		Feature: cu,
		ProjectionNode: Cc,
		MeasureLayout: pu
	}
};
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/gestures/hover.mjs
function hu(e, t, n) {
	let { props: r } = e;
	e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
	let i = r["onHover" + n];
	i && N.postRender(() => i(t, jl(t)));
}
var gu = class extends Y {
	mount() {
		let { current: e } = this.node;
		e && (this.unmount = Xi(e, (e, t) => (hu(this.node, t, "Start"), (e) => hu(this.node, e, "End"))));
	}
	unmount() {}
}, _u = class extends Y {
	constructor() {
		super(...arguments), this.isActive = !1;
	}
	onFocus() {
		let e = !1;
		try {
			e = this.node.current.matches(":focus-visible");
		} catch {
			e = !0;
		}
		!e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
	}
	onBlur() {
		!this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
	}
	mount() {
		this.unmount = pe(Fs(this.node.current, "focus", () => this.onFocus()), Fs(this.node.current, "blur", () => this.onBlur()));
	}
	unmount() {}
};
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/gestures/press.mjs
function vu(e, t, n) {
	let { props: r } = e;
	if (e.current instanceof HTMLButtonElement && e.current.disabled) return;
	e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
	let i = r["onTap" + (n === "End" ? "" : n)];
	i && N.postRender(() => i(t, jl(t)));
}
var yu = class extends Y {
	mount() {
		let { current: e } = this.node;
		if (!e) return;
		let { globalTapTarget: t, propagate: n } = this.node.props;
		this.unmount = la(e, (e, t) => (vu(this.node, t, "Start"), (e, { success: t }) => vu(this.node, e, t ? "End" : "Cancel")), {
			useGlobalTarget: t,
			stopPropagation: n?.tap === !1
		});
	}
	unmount() {}
}, bu = /* @__PURE__ */ new WeakMap(), xu = /* @__PURE__ */ new WeakMap(), Su = (e) => {
	let t = bu.get(e.target);
	t && t(e);
}, Cu = (e) => {
	e.forEach(Su);
};
function wu({ root: e, ...t }) {
	let n = e || document;
	xu.has(n) || xu.set(n, {});
	let r = xu.get(n), i = JSON.stringify(t);
	return r[i] || (r[i] = new IntersectionObserver(Cu, {
		root: e,
		...t
	})), r[i];
}
function Tu(e, t, n) {
	let r = wu(t);
	return bu.set(e, n), r.observe(e), () => {
		bu.delete(e), r.unobserve(e);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/features/viewport/index.mjs
var Eu = {
	some: 0,
	all: 1
}, Du = class extends Y {
	constructor() {
		super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
	}
	startObserver() {
		this.stopObserver?.();
		let { viewport: e = {} } = this.node.getProps(), { root: t, margin: n, amount: r = "some", once: i } = e, a = {
			root: t ? t.current : void 0,
			rootMargin: n,
			threshold: typeof r == "number" ? r : Eu[r]
		}, o = (e) => {
			let { isIntersecting: t } = e;
			if (this.isInView === t || (this.isInView = t, i && !t && this.hasEnteredView)) return;
			t && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", t);
			let { onViewportEnter: n, onViewportLeave: r } = this.node.getProps(), a = t ? n : r;
			a && a(e);
		};
		this.stopObserver = Tu(this.node.current, a, o);
	}
	mount() {
		this.startObserver();
	}
	update() {
		if (typeof IntersectionObserver > "u") return;
		let { props: e, prevProps: t } = this.node;
		[
			"amount",
			"margin",
			"root"
		].some(Ou(e, t)) && this.startObserver();
	}
	unmount() {
		this.stopObserver?.(), this.hasEnteredView = !1, this.isInView = !1;
	}
};
function Ou({ viewport: e = {} }, { viewport: t = {} } = {}) {
	return (n) => e[n] !== t[n];
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/motion/features/gestures.mjs
var ku = {
	inView: { Feature: Du },
	tap: { Feature: yu },
	focus: { Feature: _u },
	hover: { Feature: gu }
}, Au = { layout: {
	ProjectionNode: Cc,
	MeasureLayout: pu
} }, ju = /*@__PURE__*/ El({
	...Al,
	...ku,
	...mu,
	...Au
}, Dl);
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/value/use-motion-value.mjs
function Mu(e) {
	let t = ne(() => G(e)), { isStatic: n } = l(wc);
	if (n) {
		let [, n] = g(e);
		u(() => t.on("change", n), []);
	}
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/utils/is-dom-keyframes.mjs
function Nu(e) {
	return typeof e == "object" && !Array.isArray(e);
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/animate/resolve-subjects.mjs
function Pu(e, t, n, r) {
	return e == null ? [] : typeof e == "string" && Nu(t) ? Vi(e, n, r) : e instanceof NodeList ? Array.from(e) : Array.isArray(e) ? e.filter((e) => e != null) : [e];
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/sequence/utils/calc-repeat-duration.mjs
function Fu(e, t, n) {
	return e * (t + 1) + n * t;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/sequence/utils/calc-time.mjs
function Iu(e, t, n, r) {
	return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : t.startsWith("<") ? Math.max(0, n + parseFloat(t.slice(1))) : r.get(t) ?? e;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/sequence/utils/edit.mjs
function Lu(e, t, n) {
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		i.at > t && i.at < n && (oe(e, i), r--);
	}
}
function Ru(e, t, n, r, i, a) {
	Lu(e, i, a);
	for (let o = 0; o < t.length; o++) e.push({
		value: t[o],
		at: H(i, a, r[o]),
		easing: /* @__PURE__ */ Re(n, o)
	});
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/sequence/utils/normalize-times.mjs
function zu(e, t, n = 0) {
	let r = t + 1 + t * n;
	for (let t = 0; t < e.length; t++) e[t] = e[t] / r;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/sequence/utils/sort.mjs
function Bu(e, t) {
	return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/sequence/create.mjs
var Vu = "easeInOut", Hu = 20;
function Uu(e, { defaultTransition: t = {}, ...n } = {}, r, i) {
	let a = t.duration || .3, o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), c = {}, l = /* @__PURE__ */ new Map(), u = 0, d = 0, f = 0;
	for (let n = 0; n < e.length; n++) {
		let o = e[n];
		if (typeof o == "string") {
			l.set(o, d);
			continue;
		} else if (!Array.isArray(o)) {
			l.set(o.name, Iu(d, o.at, u, l));
			continue;
		}
		let [p, m, h = {}] = o;
		h.at !== void 0 && (d = Iu(d, h.at, u, l));
		let g = 0, _ = (e, n, r, o = 0, s = 0) => {
			let c = Ku(e), { delay: l = 0, times: u = xn(c), type: p = t.type || "keyframes", repeat: m, repeatType: h, repeatDelay: _ = 0, ...v } = n, { ease: y = t.ease || "easeOut", duration: b } = n, x = typeof l == "function" ? l(o, s) : l, S = c.length, C = hr(p) ? p : i?.[p || "keyframes"];
			if (S <= 2 && C) {
				let e = 100;
				if (S === 2 && Yu(c)) {
					let t = c[1] - c[0];
					e = Math.abs(t);
				}
				let n = {
					...t,
					...v
				};
				b !== void 0 && (n.duration = /* @__PURE__ */ j(b));
				let r = rn(n, e, C);
				y = r.ease, b = r.duration;
			}
			b ??= a;
			let w = d + x;
			u.length === 1 && u[0] === 0 && (u[1] = 1);
			let T = u.length - c.length;
			if (T > 0 && bn(u, T), c.length === 1 && c.unshift(null), m && ce(m < Hu, `Sequence segments can't repeat ${m} times — ignoring repeat option. Use a value below ${Hu} or apply repeat at the sequence level instead.`), m && m < Hu) {
				let e = b > 0 ? _ / b : 0;
				b = Fu(b, m, _);
				let t = [...c], n = [...u];
				y = Array.isArray(y) ? [...y] : [y];
				let r = [...y], i = h === "reverse" || h === "mirror", a = t, o = r;
				i && (a = [...t].reverse(), h === "reverse" && (o = [...r].reverse().map((e) => typeof e == "function" ? /* @__PURE__ */ Ee(e) : e)));
				for (let s = 0; s < m; s++) {
					let l = i && s % 2 == 0, d = l ? a : t, f = l ? o : r, p = (s + 1) * (1 + e);
					e > 0 && (c.push(c[c.length - 1]), u.push(p), y.push("linear")), c.push(...d);
					for (let e = 0; e < d.length; e++) u.push(n[e] + p), y.push(e === 0 ? "linear" : /* @__PURE__ */ Re(f, e - 1));
				}
				zu(u, m, e);
			}
			let E = w + b;
			Ru(r, c, y, u, w, E), g = Math.max(x + b, g), f = Math.max(E, f);
		};
		if (K(p)) {
			let e = Wu(p, s);
			_(m, h, Gu("default", e));
		} else {
			let e = Pu(p, m, r, c), t = e.length;
			for (let n = 0; n < t; n++) {
				m = m, h = h;
				let r = e[n], i = Wu(r, s);
				for (let e in m) _(m[e], qu(h, e), Gu(e, i), n, t);
			}
		}
		u = d, d += g;
	}
	return s.forEach((e, r) => {
		for (let i in e) {
			let a = e[i];
			a.sort(Bu);
			let s = [], c = [], l = [];
			for (let e = 0; e < a.length; e++) {
				let { at: t, value: n, easing: r } = a[e];
				s.push(n), c.push(/* @__PURE__ */ me(0, f, t)), l.push(r || "easeOut");
			}
			c[0] !== 0 && (c.unshift(0), s.unshift(s[0]), l.unshift(Vu)), c[c.length - 1] !== 1 && (c.push(1), s.push(null)), o.has(r) || o.set(r, {
				keyframes: {},
				transition: {}
			});
			let u = o.get(r);
			u.keyframes[i] = s;
			let { type: d, ...p } = t;
			u.transition[i] = {
				...p,
				duration: f,
				ease: l,
				times: c,
				...n
			};
		}
	}), o;
}
function Wu(e, t) {
	return !t.has(e) && t.set(e, {}), t.get(e);
}
function Gu(e, t) {
	return t[e] || (t[e] = []), t[e];
}
function Ku(e) {
	return Array.isArray(e) ? e : [e];
}
function qu(e, t) {
	return e && e[t] ? {
		...e,
		...e[t]
	} : { ...e };
}
var Ju = (e) => typeof e == "number", Yu = (e) => e.every(Ju);
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/utils/create-visual-element.mjs
function Xu(e) {
	let t = {
		presenceContext: null,
		props: {},
		visualState: {
			renderState: {
				transform: {},
				transformOrigin: {},
				style: {},
				vars: {},
				attrs: {}
			},
			latestValues: {}
		}
	}, n = ua(e) && !Ea(e) ? new Vo(t) : new ko(t);
	n.mount(e), Ma.set(e, n);
}
function Zu(e) {
	let t = new jo({
		presenceContext: null,
		props: {},
		visualState: {
			renderState: { output: {} },
			latestValues: {}
		}
	});
	t.mount(e), Ma.set(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/animate/subject.mjs
function Qu(e, t) {
	return K(e) || typeof e == "number" || typeof e == "string" && !Nu(t);
}
function $u(e, t, n, r) {
	let i = [];
	if (Qu(e, t)) i.push(Ps(e, Nu(t) && t.default || t, n && (n.default || n)));
	else {
		if (e == null) return i;
		let a = Pu(e, t, r), o = a.length;
		O(!!o, "No valid elements provided.", "no-valid-elements");
		for (let e = 0; e < o; e++) {
			let r = a[e], s = r instanceof Element ? Xu : Zu;
			Ma.has(r) || s(r);
			let c = Ma.get(r), l = { ...n };
			"delay" in l && typeof l.delay == "function" && (l.delay = l.delay(e, o)), i.push(..._i(c, {
				...t,
				transition: l
			}, {}));
		}
	}
	return i;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/animate/sequence.mjs
function ed(e, t, n) {
	let r = [];
	return Uu(e.map((e) => {
		if (Array.isArray(e) && typeof e[0] == "function") {
			let t = e[0], n = G(0);
			return n.on("change", t), e.length === 1 ? [n, [0, 1]] : e.length === 2 ? [
				n,
				[0, 1],
				e[1]
			] : [
				n,
				e[1],
				e[2]
			];
		}
		return e;
	}), t, n, { spring: mn }).forEach(({ keyframes: e, transition: t }, n) => {
		r.push(...$u(n, e, t));
	}), r;
}
//#endregion
//#region ../../node_modules/.pnpm/framer-motion@12.40.0_react_7ea1b4820433ad8864f2f384f03a8795/node_modules/framer-motion/dist/es/animation/animate/index.mjs
function td(e) {
	return Array.isArray(e) && e.some(Array.isArray);
}
function nd(e = {}) {
	let { scope: t, reduceMotion: n, skipAnimations: r } = e;
	function i(e, i, a) {
		let o = [], s, c = {};
		if (n !== void 0 && (c.reduceMotion = n), r !== void 0 && (c.skipAnimations = r), td(e)) {
			let { onComplete: n, ...r } = i || {};
			typeof n == "function" && (s = n), o = ed(e, {
				...c,
				...r
			}, t);
		} else {
			let { onComplete: n, ...r } = a || {};
			typeof n == "function" && (s = n), o = $u(e, i, {
				...c,
				...r
			}, t);
		}
		let l = new Lr(o);
		return s && l.finished.then(s), t && (t.animations.push(l), l.finished.then(() => {
			oe(t.animations, l);
		})), l;
	}
	return i;
}
var rd = nd();
//#endregion
export { Fc as i, Mu as n, ju as r, rd as t };
